/* eslint-disable */
/* tslint:disable */
/* auto-generated preact proxies */
import { createPreactComponent } from './create-preact-component';
import { defineCustomElement as defineCustomElementCosmosAssetItemBase } from '@cosmos/web/lib/custom-elements/cosmos-asset-item-base';
import { defineCustomElement as defineCustomElementCosmosAvatar } from '@cosmos/web/lib/custom-elements/cosmos-avatar';
import { defineCustomElement as defineCustomElementCosmosBadge } from '@cosmos/web/lib/custom-elements/cosmos-badge';
import { defineCustomElement as defineCustomElementCosmosButton } from '@cosmos/web/lib/custom-elements/cosmos-button';
import { defineCustomElement as defineCustomElementCosmosCheckbox } from '@cosmos/web/lib/custom-elements/cosmos-checkbox';
import { defineCustomElement as defineCustomElementCosmosCheckboxGroup } from '@cosmos/web/lib/custom-elements/cosmos-checkbox-group';
import { defineCustomElement as defineCustomElementCosmosChip } from '@cosmos/web/lib/custom-elements/cosmos-chip';
import { defineCustomElement as defineCustomElementCosmosDefaultCard } from '@cosmos/web/lib/custom-elements/cosmos-default-card';
import { defineCustomElement as defineCustomElementCosmosDefaultItem } from '@cosmos/web/lib/custom-elements/cosmos-default-item';
import { defineCustomElement as defineCustomElementCosmosFlag } from '@cosmos/web/lib/custom-elements/cosmos-flag';
import { defineCustomElement as defineCustomElementCosmosIcon } from '@cosmos/web/lib/custom-elements/cosmos-icon';
import { defineCustomElement as defineCustomElementCosmosIcon360Photo } from '@cosmos/web/lib/custom-elements/cosmos-icon-360-photo';
import { defineCustomElement as defineCustomElementCosmosIcon360Video } from '@cosmos/web/lib/custom-elements/cosmos-icon-360-video';
import { defineCustomElement as defineCustomElementCosmosIconAdd } from '@cosmos/web/lib/custom-elements/cosmos-icon-add';
import { defineCustomElement as defineCustomElementCosmosIconAirplay } from '@cosmos/web/lib/custom-elements/cosmos-icon-airplay';
import { defineCustomElement as defineCustomElementCosmosIconAlignCenter } from '@cosmos/web/lib/custom-elements/cosmos-icon-align-center';
import { defineCustomElement as defineCustomElementCosmosIconAlignLeft } from '@cosmos/web/lib/custom-elements/cosmos-icon-align-left';
import { defineCustomElement as defineCustomElementCosmosIconAlignRight } from '@cosmos/web/lib/custom-elements/cosmos-icon-align-right';
import { defineCustomElement as defineCustomElementCosmosIconAmazon } from '@cosmos/web/lib/custom-elements/cosmos-icon-amazon';
import { defineCustomElement as defineCustomElementCosmosIconAmazonBrandedDark } from '@cosmos/web/lib/custom-elements/cosmos-icon-amazon-branded-dark';
import { defineCustomElement as defineCustomElementCosmosIconAmazonBrandedLight } from '@cosmos/web/lib/custom-elements/cosmos-icon-amazon-branded-light';
import { defineCustomElement as defineCustomElementCosmosIconAmazonMusic } from '@cosmos/web/lib/custom-elements/cosmos-icon-amazon-music';
import { defineCustomElement as defineCustomElementCosmosIconAmazonMusicBranded } from '@cosmos/web/lib/custom-elements/cosmos-icon-amazon-music-branded';
import { defineCustomElement as defineCustomElementCosmosIconApple } from '@cosmos/web/lib/custom-elements/cosmos-icon-apple';
import { defineCustomElement as defineCustomElementCosmosIconApplePodcasts } from '@cosmos/web/lib/custom-elements/cosmos-icon-apple-podcasts';
import { defineCustomElement as defineCustomElementCosmosIconApplePodcastsBranded } from '@cosmos/web/lib/custom-elements/cosmos-icon-apple-podcasts-branded';
import { defineCustomElement as defineCustomElementCosmosIconAr } from '@cosmos/web/lib/custom-elements/cosmos-icon-ar';
import { defineCustomElement as defineCustomElementCosmosIconArActive } from '@cosmos/web/lib/custom-elements/cosmos-icon-ar-active';
import { defineCustomElement as defineCustomElementCosmosIconArLabel } from '@cosmos/web/lib/custom-elements/cosmos-icon-ar-label';
import { defineCustomElement as defineCustomElementCosmosIconArMobile } from '@cosmos/web/lib/custom-elements/cosmos-icon-ar-mobile';
import { defineCustomElement as defineCustomElementCosmosIconArchive } from '@cosmos/web/lib/custom-elements/cosmos-icon-archive';
import { defineCustomElement as defineCustomElementCosmosIconArrowDiagonalDownLeft } from '@cosmos/web/lib/custom-elements/cosmos-icon-arrow-diagonal-down-left';
import { defineCustomElement as defineCustomElementCosmosIconArrowDiagonalDownRight } from '@cosmos/web/lib/custom-elements/cosmos-icon-arrow-diagonal-down-right';
import { defineCustomElement as defineCustomElementCosmosIconArrowDiagonalUpLeft } from '@cosmos/web/lib/custom-elements/cosmos-icon-arrow-diagonal-up-left';
import { defineCustomElement as defineCustomElementCosmosIconArrowDiagonalUpRight } from '@cosmos/web/lib/custom-elements/cosmos-icon-arrow-diagonal-up-right';
import { defineCustomElement as defineCustomElementCosmosIconArrowDown } from '@cosmos/web/lib/custom-elements/cosmos-icon-arrow-down';
import { defineCustomElement as defineCustomElementCosmosIconArrowDownUp } from '@cosmos/web/lib/custom-elements/cosmos-icon-arrow-down-up';
import { defineCustomElement as defineCustomElementCosmosIconArrowLeft } from '@cosmos/web/lib/custom-elements/cosmos-icon-arrow-left';
import { defineCustomElement as defineCustomElementCosmosIconArrowReturnLeft } from '@cosmos/web/lib/custom-elements/cosmos-icon-arrow-return-left';
import { defineCustomElement as defineCustomElementCosmosIconArrowReturnRight } from '@cosmos/web/lib/custom-elements/cosmos-icon-arrow-return-right';
import { defineCustomElement as defineCustomElementCosmosIconArrowRight } from '@cosmos/web/lib/custom-elements/cosmos-icon-arrow-right';
import { defineCustomElement as defineCustomElementCosmosIconArrowTriangleLeft } from '@cosmos/web/lib/custom-elements/cosmos-icon-arrow-triangle-left';
import { defineCustomElement as defineCustomElementCosmosIconArrowTriangleRight } from '@cosmos/web/lib/custom-elements/cosmos-icon-arrow-triangle-right';
import { defineCustomElement as defineCustomElementCosmosIconArrowUp } from '@cosmos/web/lib/custom-elements/cosmos-icon-arrow-up';
import { defineCustomElement as defineCustomElementCosmosIconAuthor } from '@cosmos/web/lib/custom-elements/cosmos-icon-author';
import { defineCustomElement as defineCustomElementCosmosIconBack } from '@cosmos/web/lib/custom-elements/cosmos-icon-back';
import { defineCustomElement as defineCustomElementCosmosIconBack10 } from '@cosmos/web/lib/custom-elements/cosmos-icon-back-10';
import { defineCustomElement as defineCustomElementCosmosIconBack15 } from '@cosmos/web/lib/custom-elements/cosmos-icon-back-15';
import { defineCustomElement as defineCustomElementCosmosIconBack20 } from '@cosmos/web/lib/custom-elements/cosmos-icon-back-20';
import { defineCustomElement as defineCustomElementCosmosIconBackward } from '@cosmos/web/lib/custom-elements/cosmos-icon-backward';
import { defineCustomElement as defineCustomElementCosmosIconBandsintown } from '@cosmos/web/lib/custom-elements/cosmos-icon-bandsintown';
import { defineCustomElement as defineCustomElementCosmosIconBandsintownBranded } from '@cosmos/web/lib/custom-elements/cosmos-icon-bandsintown-branded';
import { defineCustomElement as defineCustomElementCosmosIconBaseballCap } from '@cosmos/web/lib/custom-elements/cosmos-icon-baseball-cap';
import { defineCustomElement as defineCustomElementCosmosIconBookmark } from '@cosmos/web/lib/custom-elements/cosmos-icon-bookmark';
import { defineCustomElement as defineCustomElementCosmosIconBookmarkFilled } from '@cosmos/web/lib/custom-elements/cosmos-icon-bookmark-filled';
import { defineCustomElement as defineCustomElementCosmosIconBrowse } from '@cosmos/web/lib/custom-elements/cosmos-icon-browse';
import { defineCustomElement as defineCustomElementCosmosIconBrowseFilled } from '@cosmos/web/lib/custom-elements/cosmos-icon-browse-filled';
import { defineCustomElement as defineCustomElementCosmosIconBulb } from '@cosmos/web/lib/custom-elements/cosmos-icon-bulb';
import { defineCustomElement as defineCustomElementCosmosIconBulbFilled } from '@cosmos/web/lib/custom-elements/cosmos-icon-bulb-filled';
import { defineCustomElement as defineCustomElementCosmosIconBuyTickets } from '@cosmos/web/lib/custom-elements/cosmos-icon-buy-tickets';
import { defineCustomElement as defineCustomElementCosmosIconCalendar } from '@cosmos/web/lib/custom-elements/cosmos-icon-calendar';
import { defineCustomElement as defineCustomElementCosmosIconCalendarFilled } from '@cosmos/web/lib/custom-elements/cosmos-icon-calendar-filled';
import { defineCustomElement as defineCustomElementCosmosIconCan } from '@cosmos/web/lib/custom-elements/cosmos-icon-can';
import { defineCustomElement as defineCustomElementCosmosIconCanInverted } from '@cosmos/web/lib/custom-elements/cosmos-icon-can-inverted';
import { defineCustomElement as defineCustomElementCosmosIconCancel } from '@cosmos/web/lib/custom-elements/cosmos-icon-cancel';
import { defineCustomElement as defineCustomElementCosmosIconCaptions } from '@cosmos/web/lib/custom-elements/cosmos-icon-captions';
import { defineCustomElement as defineCustomElementCosmosIconCaptionsFilled } from '@cosmos/web/lib/custom-elements/cosmos-icon-captions-filled';
import { defineCustomElement as defineCustomElementCosmosIconCaretDown } from '@cosmos/web/lib/custom-elements/cosmos-icon-caret-down';
import { defineCustomElement as defineCustomElementCosmosIconCaretLeft } from '@cosmos/web/lib/custom-elements/cosmos-icon-caret-left';
import { defineCustomElement as defineCustomElementCosmosIconCaretRight } from '@cosmos/web/lib/custom-elements/cosmos-icon-caret-right';
import { defineCustomElement as defineCustomElementCosmosIconCaretUp } from '@cosmos/web/lib/custom-elements/cosmos-icon-caret-up';
import { defineCustomElement as defineCustomElementCosmosIconChatAdd } from '@cosmos/web/lib/custom-elements/cosmos-icon-chat-add';
import { defineCustomElement as defineCustomElementCosmosIconCheckboxChecked } from '@cosmos/web/lib/custom-elements/cosmos-icon-checkbox-checked';
import { defineCustomElement as defineCustomElementCosmosIconCheckboxUnchecked } from '@cosmos/web/lib/custom-elements/cosmos-icon-checkbox-unchecked';
import { defineCustomElement as defineCustomElementCosmosIconCheckmark } from '@cosmos/web/lib/custom-elements/cosmos-icon-checkmark';
import { defineCustomElement as defineCustomElementCosmosIconCheckout } from '@cosmos/web/lib/custom-elements/cosmos-icon-checkout';
import { defineCustomElement as defineCustomElementCosmosIconChevronDown } from '@cosmos/web/lib/custom-elements/cosmos-icon-chevron-down';
import { defineCustomElement as defineCustomElementCosmosIconChevronLeft } from '@cosmos/web/lib/custom-elements/cosmos-icon-chevron-left';
import { defineCustomElement as defineCustomElementCosmosIconChevronRight } from '@cosmos/web/lib/custom-elements/cosmos-icon-chevron-right';
import { defineCustomElement as defineCustomElementCosmosIconChevronUp } from '@cosmos/web/lib/custom-elements/cosmos-icon-chevron-up';
import { defineCustomElement as defineCustomElementCosmosIconChromecast } from '@cosmos/web/lib/custom-elements/cosmos-icon-chromecast';
import { defineCustomElement as defineCustomElementCosmosIconChromecastFilled } from '@cosmos/web/lib/custom-elements/cosmos-icon-chromecast-filled';
import { defineCustomElement as defineCustomElementCosmosIconClear } from '@cosmos/web/lib/custom-elements/cosmos-icon-clear';
import { defineCustomElement as defineCustomElementCosmosIconClip } from '@cosmos/web/lib/custom-elements/cosmos-icon-clip';
import { defineCustomElement as defineCustomElementCosmosIconClock } from '@cosmos/web/lib/custom-elements/cosmos-icon-clock';
import { defineCustomElement as defineCustomElementCosmosIconClose } from '@cosmos/web/lib/custom-elements/cosmos-icon-close';
import { defineCustomElement as defineCustomElementCosmosIconCloseSmall } from '@cosmos/web/lib/custom-elements/cosmos-icon-close-small';
import { defineCustomElement as defineCustomElementCosmosIconCloud } from '@cosmos/web/lib/custom-elements/cosmos-icon-cloud';
import { defineCustomElement as defineCustomElementCosmosIconCodeBlock } from '@cosmos/web/lib/custom-elements/cosmos-icon-code-block';
import { defineCustomElement as defineCustomElementCosmosIconCollapse } from '@cosmos/web/lib/custom-elements/cosmos-icon-collapse';
import { defineCustomElement as defineCustomElementCosmosIconCollapseArrows } from '@cosmos/web/lib/custom-elements/cosmos-icon-collapse-arrows';
import { defineCustomElement as defineCustomElementCosmosIconCollapseHorizontal } from '@cosmos/web/lib/custom-elements/cosmos-icon-collapse-horizontal';
import { defineCustomElement as defineCustomElementCosmosIconCollapseVertical } from '@cosmos/web/lib/custom-elements/cosmos-icon-collapse-vertical';
import { defineCustomElement as defineCustomElementCosmosIconColumns } from '@cosmos/web/lib/custom-elements/cosmos-icon-columns';
import { defineCustomElement as defineCustomElementCosmosIconComment } from '@cosmos/web/lib/custom-elements/cosmos-icon-comment';
import { defineCustomElement as defineCustomElementCosmosIconContextual } from '@cosmos/web/lib/custom-elements/cosmos-icon-contextual';
import { defineCustomElement as defineCustomElementCosmosIconContract } from '@cosmos/web/lib/custom-elements/cosmos-icon-contract';
import { defineCustomElement as defineCustomElementCosmosIconCopyLink } from '@cosmos/web/lib/custom-elements/cosmos-icon-copy-link';
import { defineCustomElement as defineCustomElementCosmosIconCountry } from '@cosmos/web/lib/custom-elements/cosmos-icon-country';
import { defineCustomElement as defineCustomElementCosmosIconCouple } from '@cosmos/web/lib/custom-elements/cosmos-icon-couple';
import { defineCustomElement as defineCustomElementCosmosIconCrashed } from '@cosmos/web/lib/custom-elements/cosmos-icon-crashed';
import { defineCustomElement as defineCustomElementCosmosIconCreate } from '@cosmos/web/lib/custom-elements/cosmos-icon-create';
import { defineCustomElement as defineCustomElementCosmosIconCrew } from '@cosmos/web/lib/custom-elements/cosmos-icon-crew';
import { defineCustomElement as defineCustomElementCosmosIconCrop } from '@cosmos/web/lib/custom-elements/cosmos-icon-crop';
import { defineCustomElement as defineCustomElementCosmosIconCurrency } from '@cosmos/web/lib/custom-elements/cosmos-icon-currency';
import { defineCustomElement as defineCustomElementCosmosIconCurrentlyWatching } from '@cosmos/web/lib/custom-elements/cosmos-icon-currently-watching';
import { defineCustomElement as defineCustomElementCosmosIconCut } from '@cosmos/web/lib/custom-elements/cosmos-icon-cut';
import { defineCustomElement as defineCustomElementCosmosIconDeezer } from '@cosmos/web/lib/custom-elements/cosmos-icon-deezer';
import { defineCustomElement as defineCustomElementCosmosIconDeezerBranded } from '@cosmos/web/lib/custom-elements/cosmos-icon-deezer-branded';
import { defineCustomElement as defineCustomElementCosmosIconDelete } from '@cosmos/web/lib/custom-elements/cosmos-icon-delete';
import { defineCustomElement as defineCustomElementCosmosIconDelivery } from '@cosmos/web/lib/custom-elements/cosmos-icon-delivery';
import { defineCustomElement as defineCustomElementCosmosIconDesktop } from '@cosmos/web/lib/custom-elements/cosmos-icon-desktop';
import { defineCustomElement as defineCustomElementCosmosIconDevices } from '@cosmos/web/lib/custom-elements/cosmos-icon-devices';
import { defineCustomElement as defineCustomElementCosmosIconDirections } from '@cosmos/web/lib/custom-elements/cosmos-icon-directions';
import { defineCustomElement as defineCustomElementCosmosIconDiscover } from '@cosmos/web/lib/custom-elements/cosmos-icon-discover';
import { defineCustomElement as defineCustomElementCosmosIconDocumentFiling } from '@cosmos/web/lib/custom-elements/cosmos-icon-document-filing';
import { defineCustomElement as defineCustomElementCosmosIconDocumentFiling2 } from '@cosmos/web/lib/custom-elements/cosmos-icon-document-filing-2';
import { defineCustomElement as defineCustomElementCosmosIconDocumentFilled } from '@cosmos/web/lib/custom-elements/cosmos-icon-document-filled';
import { defineCustomElement as defineCustomElementCosmosIconDownload } from '@cosmos/web/lib/custom-elements/cosmos-icon-download';
import { defineCustomElement as defineCustomElementCosmosIconDownloadError } from '@cosmos/web/lib/custom-elements/cosmos-icon-download-error';
import { defineCustomElement as defineCustomElementCosmosIconDownloading } from '@cosmos/web/lib/custom-elements/cosmos-icon-downloading';
import { defineCustomElement as defineCustomElementCosmosIconDragHandleHorizontal } from '@cosmos/web/lib/custom-elements/cosmos-icon-drag-handle-horizontal';
import { defineCustomElement as defineCustomElementCosmosIconDragHandleVertical } from '@cosmos/web/lib/custom-elements/cosmos-icon-drag-handle-vertical';
import { defineCustomElement as defineCustomElementCosmosIconDrink } from '@cosmos/web/lib/custom-elements/cosmos-icon-drink';
import { defineCustomElement as defineCustomElementCosmosIconDuplicate } from '@cosmos/web/lib/custom-elements/cosmos-icon-duplicate';
import { defineCustomElement as defineCustomElementCosmosIconEdit } from '@cosmos/web/lib/custom-elements/cosmos-icon-edit';
import { defineCustomElement as defineCustomElementCosmosIconEmail } from '@cosmos/web/lib/custom-elements/cosmos-icon-email';
import { defineCustomElement as defineCustomElementCosmosIconEmoji } from '@cosmos/web/lib/custom-elements/cosmos-icon-emoji';
import { defineCustomElement as defineCustomElementCosmosIconEnlarge } from '@cosmos/web/lib/custom-elements/cosmos-icon-enlarge';
import { defineCustomElement as defineCustomElementCosmosIconEnvelopeFilled } from '@cosmos/web/lib/custom-elements/cosmos-icon-envelope-filled';
import { defineCustomElement as defineCustomElementCosmosIconEpg } from '@cosmos/web/lib/custom-elements/cosmos-icon-epg';
import { defineCustomElement as defineCustomElementCosmosIconEpisode } from '@cosmos/web/lib/custom-elements/cosmos-icon-episode';
import { defineCustomElement as defineCustomElementCosmosIconErrorFilled } from '@cosmos/web/lib/custom-elements/cosmos-icon-error-filled';
import { defineCustomElement as defineCustomElementCosmosIconEvent } from '@cosmos/web/lib/custom-elements/cosmos-icon-event';
import { defineCustomElement as defineCustomElementCosmosIconEventDetails } from '@cosmos/web/lib/custom-elements/cosmos-icon-event-details';
import { defineCustomElement as defineCustomElementCosmosIconEventEnd } from '@cosmos/web/lib/custom-elements/cosmos-icon-event-end';
import { defineCustomElement as defineCustomElementCosmosIconEventSeries } from '@cosmos/web/lib/custom-elements/cosmos-icon-event-series';
import { defineCustomElement as defineCustomElementCosmosIconEventStart } from '@cosmos/web/lib/custom-elements/cosmos-icon-event-start';
import { defineCustomElement as defineCustomElementCosmosIconExpand } from '@cosmos/web/lib/custom-elements/cosmos-icon-expand';
import { defineCustomElement as defineCustomElementCosmosIconExpandArrows } from '@cosmos/web/lib/custom-elements/cosmos-icon-expand-arrows';
import { defineCustomElement as defineCustomElementCosmosIconExpandHorizontal } from '@cosmos/web/lib/custom-elements/cosmos-icon-expand-horizontal';
import { defineCustomElement as defineCustomElementCosmosIconExpandLess } from '@cosmos/web/lib/custom-elements/cosmos-icon-expand-less';
import { defineCustomElement as defineCustomElementCosmosIconExpandMore } from '@cosmos/web/lib/custom-elements/cosmos-icon-expand-more';
import { defineCustomElement as defineCustomElementCosmosIconExpandVertical } from '@cosmos/web/lib/custom-elements/cosmos-icon-expand-vertical';
import { defineCustomElement as defineCustomElementCosmosIconExternalLink } from '@cosmos/web/lib/custom-elements/cosmos-icon-external-link';
import { defineCustomElement as defineCustomElementCosmosIconFacebook } from '@cosmos/web/lib/custom-elements/cosmos-icon-facebook';
import { defineCustomElement as defineCustomElementCosmosIconFacebookBranded } from '@cosmos/web/lib/custom-elements/cosmos-icon-facebook-branded';
import { defineCustomElement as defineCustomElementCosmosIconFastCheckout } from '@cosmos/web/lib/custom-elements/cosmos-icon-fast-checkout';
import { defineCustomElement as defineCustomElementCosmosIconFastForward } from '@cosmos/web/lib/custom-elements/cosmos-icon-fast-forward';
import { defineCustomElement as defineCustomElementCosmosIconFastRewind } from '@cosmos/web/lib/custom-elements/cosmos-icon-fast-rewind';
import { defineCustomElement as defineCustomElementCosmosIconFeatureFilm } from '@cosmos/web/lib/custom-elements/cosmos-icon-feature-film';
import { defineCustomElement as defineCustomElementCosmosIconFeedback } from '@cosmos/web/lib/custom-elements/cosmos-icon-feedback';
import { defineCustomElement as defineCustomElementCosmosIconFeedbackFilled } from '@cosmos/web/lib/custom-elements/cosmos-icon-feedback-filled';
import { defineCustomElement as defineCustomElementCosmosIconFemale } from '@cosmos/web/lib/custom-elements/cosmos-icon-female';
import { defineCustomElement as defineCustomElementCosmosIconFileDownload } from '@cosmos/web/lib/custom-elements/cosmos-icon-file-download';
import { defineCustomElement as defineCustomElementCosmosIconFileRemove } from '@cosmos/web/lib/custom-elements/cosmos-icon-file-remove';
import { defineCustomElement as defineCustomElementCosmosIconFileUpload } from '@cosmos/web/lib/custom-elements/cosmos-icon-file-upload';
import { defineCustomElement as defineCustomElementCosmosIconFilmCamera } from '@cosmos/web/lib/custom-elements/cosmos-icon-film-camera';
import { defineCustomElement as defineCustomElementCosmosIconFilms } from '@cosmos/web/lib/custom-elements/cosmos-icon-films';
import { defineCustomElement as defineCustomElementCosmosIconFilter } from '@cosmos/web/lib/custom-elements/cosmos-icon-filter';
import { defineCustomElement as defineCustomElementCosmosIconFilterList } from '@cosmos/web/lib/custom-elements/cosmos-icon-filter-list';
import { defineCustomElement as defineCustomElementCosmosIconFilterRemove } from '@cosmos/web/lib/custom-elements/cosmos-icon-filter-remove';
import { defineCustomElement as defineCustomElementCosmosIconFlag } from '@cosmos/web/lib/custom-elements/cosmos-icon-flag';
import { defineCustomElement as defineCustomElementCosmosIconFolder } from '@cosmos/web/lib/custom-elements/cosmos-icon-folder';
import { defineCustomElement as defineCustomElementCosmosIconFolderAdd } from '@cosmos/web/lib/custom-elements/cosmos-icon-folder-add';
import { defineCustomElement as defineCustomElementCosmosIconFolderDownload } from '@cosmos/web/lib/custom-elements/cosmos-icon-folder-download';
import { defineCustomElement as defineCustomElementCosmosIconFolderOpen } from '@cosmos/web/lib/custom-elements/cosmos-icon-folder-open';
import { defineCustomElement as defineCustomElementCosmosIconFolderRemove } from '@cosmos/web/lib/custom-elements/cosmos-icon-folder-remove';
import { defineCustomElement as defineCustomElementCosmosIconFolderShared } from '@cosmos/web/lib/custom-elements/cosmos-icon-folder-shared';
import { defineCustomElement as defineCustomElementCosmosIconFolderUpload } from '@cosmos/web/lib/custom-elements/cosmos-icon-folder-upload';
import { defineCustomElement as defineCustomElementCosmosIconFormatBold } from '@cosmos/web/lib/custom-elements/cosmos-icon-format-bold';
import { defineCustomElement as defineCustomElementCosmosIconFormatListNumbered } from '@cosmos/web/lib/custom-elements/cosmos-icon-format-list-numbered';
import { defineCustomElement as defineCustomElementCosmosIconFormatQuote } from '@cosmos/web/lib/custom-elements/cosmos-icon-format-quote';
import { defineCustomElement as defineCustomElementCosmosIconFormatSize } from '@cosmos/web/lib/custom-elements/cosmos-icon-format-size';
import { defineCustomElement as defineCustomElementCosmosIconFormatUnderline } from '@cosmos/web/lib/custom-elements/cosmos-icon-format-underline';
import { defineCustomElement as defineCustomElementCosmosIconForward } from '@cosmos/web/lib/custom-elements/cosmos-icon-forward';
import { defineCustomElement as defineCustomElementCosmosIconForward10 } from '@cosmos/web/lib/custom-elements/cosmos-icon-forward-10';
import { defineCustomElement as defineCustomElementCosmosIconForward15 } from '@cosmos/web/lib/custom-elements/cosmos-icon-forward-15';
import { defineCustomElement as defineCustomElementCosmosIconForward20 } from '@cosmos/web/lib/custom-elements/cosmos-icon-forward-20';
import { defineCustomElement as defineCustomElementCosmosIconFullscreen } from '@cosmos/web/lib/custom-elements/cosmos-icon-fullscreen';
import { defineCustomElement as defineCustomElementCosmosIconFullscreenExit } from '@cosmos/web/lib/custom-elements/cosmos-icon-fullscreen-exit';
import { defineCustomElement as defineCustomElementCosmosIconFunnel } from '@cosmos/web/lib/custom-elements/cosmos-icon-funnel';
import { defineCustomElement as defineCustomElementCosmosIconFunnelRemove } from '@cosmos/web/lib/custom-elements/cosmos-icon-funnel-remove';
import { defineCustomElement as defineCustomElementCosmosIconGallery } from '@cosmos/web/lib/custom-elements/cosmos-icon-gallery';
import { defineCustomElement as defineCustomElementCosmosIconGame } from '@cosmos/web/lib/custom-elements/cosmos-icon-game';
import { defineCustomElement as defineCustomElementCosmosIconGenericContent } from '@cosmos/web/lib/custom-elements/cosmos-icon-generic-content';
import { defineCustomElement as defineCustomElementCosmosIconGlobeGeo } from '@cosmos/web/lib/custom-elements/cosmos-icon-globe-geo';
import { defineCustomElement as defineCustomElementCosmosIconGoogle } from '@cosmos/web/lib/custom-elements/cosmos-icon-google';
import { defineCustomElement as defineCustomElementCosmosIconGoogleBranded } from '@cosmos/web/lib/custom-elements/cosmos-icon-google-branded';
import { defineCustomElement as defineCustomElementCosmosIconGooglePlay } from '@cosmos/web/lib/custom-elements/cosmos-icon-google-play';
import { defineCustomElement as defineCustomElementCosmosIconGooglePlayBranded } from '@cosmos/web/lib/custom-elements/cosmos-icon-google-play-branded';
import { defineCustomElement as defineCustomElementCosmosIconGooglePodcasts } from '@cosmos/web/lib/custom-elements/cosmos-icon-google-podcasts';
import { defineCustomElement as defineCustomElementCosmosIconGooglePodcastsBranded } from '@cosmos/web/lib/custom-elements/cosmos-icon-google-podcasts-branded';
import { defineCustomElement as defineCustomElementCosmosIconGrid } from '@cosmos/web/lib/custom-elements/cosmos-icon-grid';
import { defineCustomElement as defineCustomElementCosmosIconGridLayout } from '@cosmos/web/lib/custom-elements/cosmos-icon-grid-layout';
import { defineCustomElement as defineCustomElementCosmosIconGridLive } from '@cosmos/web/lib/custom-elements/cosmos-icon-grid-live';
import { defineCustomElement as defineCustomElementCosmosIconHeadline } from '@cosmos/web/lib/custom-elements/cosmos-icon-headline';
import { defineCustomElement as defineCustomElementCosmosIconHeadphones } from '@cosmos/web/lib/custom-elements/cosmos-icon-headphones';
import { defineCustomElement as defineCustomElementCosmosIconHeart } from '@cosmos/web/lib/custom-elements/cosmos-icon-heart';
import { defineCustomElement as defineCustomElementCosmosIconHeartFilled } from '@cosmos/web/lib/custom-elements/cosmos-icon-heart-filled';
import { defineCustomElement as defineCustomElementCosmosIconHighlights } from '@cosmos/web/lib/custom-elements/cosmos-icon-highlights';
import { defineCustomElement as defineCustomElementCosmosIconHistory } from '@cosmos/web/lib/custom-elements/cosmos-icon-history';
import { defineCustomElement as defineCustomElementCosmosIconHome } from '@cosmos/web/lib/custom-elements/cosmos-icon-home';
import { defineCustomElement as defineCustomElementCosmosIconHomeFilled } from '@cosmos/web/lib/custom-elements/cosmos-icon-home-filled';
import { defineCustomElement as defineCustomElementCosmosIconHot } from '@cosmos/web/lib/custom-elements/cosmos-icon-hot';
import { defineCustomElement as defineCustomElementCosmosIconHourglassEmpty } from '@cosmos/web/lib/custom-elements/cosmos-icon-hourglass-empty';
import { defineCustomElement as defineCustomElementCosmosIconHourglassFull } from '@cosmos/web/lib/custom-elements/cosmos-icon-hourglass-full';
import { defineCustomElement as defineCustomElementCosmosIconImage } from '@cosmos/web/lib/custom-elements/cosmos-icon-image';
import { defineCustomElement as defineCustomElementCosmosIconImageGallery } from '@cosmos/web/lib/custom-elements/cosmos-icon-image-gallery';
import { defineCustomElement as defineCustomElementCosmosIconImageInPicture } from '@cosmos/web/lib/custom-elements/cosmos-icon-image-in-picture';
import { defineCustomElement as defineCustomElementCosmosIconInProgress } from '@cosmos/web/lib/custom-elements/cosmos-icon-in-progress';
import { defineCustomElement as defineCustomElementCosmosIconInfo } from '@cosmos/web/lib/custom-elements/cosmos-icon-info';
import { defineCustomElement as defineCustomElementCosmosIconInfoFilled } from '@cosmos/web/lib/custom-elements/cosmos-icon-info-filled';
import { defineCustomElement as defineCustomElementCosmosIconInfoHeatAnalyser } from '@cosmos/web/lib/custom-elements/cosmos-icon-info-heat-analyser';
import { defineCustomElement as defineCustomElementCosmosIconInfoMulticolored } from '@cosmos/web/lib/custom-elements/cosmos-icon-info-multicolored';
import { defineCustomElement as defineCustomElementCosmosIconInfographic } from '@cosmos/web/lib/custom-elements/cosmos-icon-infographic';
import { defineCustomElement as defineCustomElementCosmosIconInstagram } from '@cosmos/web/lib/custom-elements/cosmos-icon-instagram';
import { defineCustomElement as defineCustomElementCosmosIconInstagramBranded } from '@cosmos/web/lib/custom-elements/cosmos-icon-instagram-branded';
import { defineCustomElement as defineCustomElementCosmosIconInterview } from '@cosmos/web/lib/custom-elements/cosmos-icon-interview';
import { defineCustomElement as defineCustomElementCosmosIconInvoice } from '@cosmos/web/lib/custom-elements/cosmos-icon-invoice';
import { defineCustomElement as defineCustomElementCosmosIconItalic } from '@cosmos/web/lib/custom-elements/cosmos-icon-italic';
import { defineCustomElement as defineCustomElementCosmosIconKeyboard } from '@cosmos/web/lib/custom-elements/cosmos-icon-keyboard';
import { defineCustomElement as defineCustomElementCosmosIconLabel } from '@cosmos/web/lib/custom-elements/cosmos-icon-label';
import { defineCustomElement as defineCustomElementCosmosIconLanguage } from '@cosmos/web/lib/custom-elements/cosmos-icon-language';
import { defineCustomElement as defineCustomElementCosmosIconLaptop } from '@cosmos/web/lib/custom-elements/cosmos-icon-laptop';
import { defineCustomElement as defineCustomElementCosmosIconLaunch } from '@cosmos/web/lib/custom-elements/cosmos-icon-launch';
import { defineCustomElement as defineCustomElementCosmosIconLink } from '@cosmos/web/lib/custom-elements/cosmos-icon-link';
import { defineCustomElement as defineCustomElementCosmosIconLinkedin } from '@cosmos/web/lib/custom-elements/cosmos-icon-linkedin';
import { defineCustomElement as defineCustomElementCosmosIconLinkedinBranded } from '@cosmos/web/lib/custom-elements/cosmos-icon-linkedin-branded';
import { defineCustomElement as defineCustomElementCosmosIconLinkedinLogo } from '@cosmos/web/lib/custom-elements/cosmos-icon-linkedin-logo';
import { defineCustomElement as defineCustomElementCosmosIconList } from '@cosmos/web/lib/custom-elements/cosmos-icon-list';
import { defineCustomElement as defineCustomElementCosmosIconLive } from '@cosmos/web/lib/custom-elements/cosmos-icon-live';
import { defineCustomElement as defineCustomElementCosmosIconLiveBroadcast } from '@cosmos/web/lib/custom-elements/cosmos-icon-live-broadcast';
import { defineCustomElement as defineCustomElementCosmosIconLoading } from '@cosmos/web/lib/custom-elements/cosmos-icon-loading';
import { defineCustomElement as defineCustomElementCosmosIconLocation } from '@cosmos/web/lib/custom-elements/cosmos-icon-location';
import { defineCustomElement as defineCustomElementCosmosIconLockFilled } from '@cosmos/web/lib/custom-elements/cosmos-icon-lock-filled';
import { defineCustomElement as defineCustomElementCosmosIconLockOpen } from '@cosmos/web/lib/custom-elements/cosmos-icon-lock-open';
import { defineCustomElement as defineCustomElementCosmosIconMagicWand } from '@cosmos/web/lib/custom-elements/cosmos-icon-magic-wand';
import { defineCustomElement as defineCustomElementCosmosIconMale } from '@cosmos/web/lib/custom-elements/cosmos-icon-male';
import { defineCustomElement as defineCustomElementCosmosIconMap } from '@cosmos/web/lib/custom-elements/cosmos-icon-map';
import { defineCustomElement as defineCustomElementCosmosIconMegaphone } from '@cosmos/web/lib/custom-elements/cosmos-icon-megaphone';
import { defineCustomElement as defineCustomElementCosmosIconMenu } from '@cosmos/web/lib/custom-elements/cosmos-icon-menu';
import { defineCustomElement as defineCustomElementCosmosIconMenuNotification } from '@cosmos/web/lib/custom-elements/cosmos-icon-menu-notification';
import { defineCustomElement as defineCustomElementCosmosIconMenuPulsating } from '@cosmos/web/lib/custom-elements/cosmos-icon-menu-pulsating';
import { defineCustomElement as defineCustomElementCosmosIconMessenger } from '@cosmos/web/lib/custom-elements/cosmos-icon-messenger';
import { defineCustomElement as defineCustomElementCosmosIconMessengerBranded } from '@cosmos/web/lib/custom-elements/cosmos-icon-messenger-branded';
import { defineCustomElement as defineCustomElementCosmosIconMinus } from '@cosmos/web/lib/custom-elements/cosmos-icon-minus';
import { defineCustomElement as defineCustomElementCosmosIconMixer } from '@cosmos/web/lib/custom-elements/cosmos-icon-mixer';
import { defineCustomElement as defineCustomElementCosmosIconModeDark } from '@cosmos/web/lib/custom-elements/cosmos-icon-mode-dark';
import { defineCustomElement as defineCustomElementCosmosIconModeLight } from '@cosmos/web/lib/custom-elements/cosmos-icon-mode-light';
import { defineCustomElement as defineCustomElementCosmosIconMore } from '@cosmos/web/lib/custom-elements/cosmos-icon-more';
import { defineCustomElement as defineCustomElementCosmosIconMountain } from '@cosmos/web/lib/custom-elements/cosmos-icon-mountain';
import { defineCustomElement as defineCustomElementCosmosIconMouse } from '@cosmos/web/lib/custom-elements/cosmos-icon-mouse';
import { defineCustomElement as defineCustomElementCosmosIconMultiLanguage } from '@cosmos/web/lib/custom-elements/cosmos-icon-multi-language';
import { defineCustomElement as defineCustomElementCosmosIconMute } from '@cosmos/web/lib/custom-elements/cosmos-icon-mute';
import { defineCustomElement as defineCustomElementCosmosIconMyLocation } from '@cosmos/web/lib/custom-elements/cosmos-icon-my-location';
import { defineCustomElement as defineCustomElementCosmosIconNews } from '@cosmos/web/lib/custom-elements/cosmos-icon-news';
import { defineCustomElement as defineCustomElementCosmosIconNoConnection } from '@cosmos/web/lib/custom-elements/cosmos-icon-no-connection';
import { defineCustomElement as defineCustomElementCosmosIconNoData } from '@cosmos/web/lib/custom-elements/cosmos-icon-no-data';
import { defineCustomElement as defineCustomElementCosmosIconPagination } from '@cosmos/web/lib/custom-elements/cosmos-icon-pagination';
import { defineCustomElement as defineCustomElementCosmosIconPaginationFilled } from '@cosmos/web/lib/custom-elements/cosmos-icon-pagination-filled';
import { defineCustomElement as defineCustomElementCosmosIconParcel } from '@cosmos/web/lib/custom-elements/cosmos-icon-parcel';
import { defineCustomElement as defineCustomElementCosmosIconPartnerProfile } from '@cosmos/web/lib/custom-elements/cosmos-icon-partner-profile';
import { defineCustomElement as defineCustomElementCosmosIconPaste } from '@cosmos/web/lib/custom-elements/cosmos-icon-paste';
import { defineCustomElement as defineCustomElementCosmosIconPause } from '@cosmos/web/lib/custom-elements/cosmos-icon-pause';
import { defineCustomElement as defineCustomElementCosmosIconPayment } from '@cosmos/web/lib/custom-elements/cosmos-icon-payment';
import { defineCustomElement as defineCustomElementCosmosIconPen } from '@cosmos/web/lib/custom-elements/cosmos-icon-pen';
import { defineCustomElement as defineCustomElementCosmosIconPersonFollow } from '@cosmos/web/lib/custom-elements/cosmos-icon-person-follow';
import { defineCustomElement as defineCustomElementCosmosIconPersonFollowing } from '@cosmos/web/lib/custom-elements/cosmos-icon-person-following';
import { defineCustomElement as defineCustomElementCosmosIconPersonProfileFilled } from '@cosmos/web/lib/custom-elements/cosmos-icon-person-profile-filled';
import { defineCustomElement as defineCustomElementCosmosIconPhone } from '@cosmos/web/lib/custom-elements/cosmos-icon-phone';
import { defineCustomElement as defineCustomElementCosmosIconPhotoCamera } from '@cosmos/web/lib/custom-elements/cosmos-icon-photo-camera';
import { defineCustomElement as defineCustomElementCosmosIconPhotoCameraReverse } from '@cosmos/web/lib/custom-elements/cosmos-icon-photo-camera-reverse';
import { defineCustomElement as defineCustomElementCosmosIconPictureInPicture } from '@cosmos/web/lib/custom-elements/cosmos-icon-picture-in-picture';
import { defineCustomElement as defineCustomElementCosmosIconPieOutline } from '@cosmos/web/lib/custom-elements/cosmos-icon-pie-outline';
import { defineCustomElement as defineCustomElementCosmosIconPinterest } from '@cosmos/web/lib/custom-elements/cosmos-icon-pinterest';
import { defineCustomElement as defineCustomElementCosmosIconPinterestBranded } from '@cosmos/web/lib/custom-elements/cosmos-icon-pinterest-branded';
import { defineCustomElement as defineCustomElementCosmosIconPlay } from '@cosmos/web/lib/custom-elements/cosmos-icon-play';
import { defineCustomElement as defineCustomElementCosmosIconPlaylist } from '@cosmos/web/lib/custom-elements/cosmos-icon-playlist';
import { defineCustomElement as defineCustomElementCosmosIconPlaylistPersonalised } from '@cosmos/web/lib/custom-elements/cosmos-icon-playlist-personalised';
import { defineCustomElement as defineCustomElementCosmosIconPlus } from '@cosmos/web/lib/custom-elements/cosmos-icon-plus';
import { defineCustomElement as defineCustomElementCosmosIconPodcast } from '@cosmos/web/lib/custom-elements/cosmos-icon-podcast';
import { defineCustomElement as defineCustomElementCosmosIconPresentation } from '@cosmos/web/lib/custom-elements/cosmos-icon-presentation';
import { defineCustomElement as defineCustomElementCosmosIconPreview } from '@cosmos/web/lib/custom-elements/cosmos-icon-preview';
import { defineCustomElement as defineCustomElementCosmosIconPreviewFilled } from '@cosmos/web/lib/custom-elements/cosmos-icon-preview-filled';
import { defineCustomElement as defineCustomElementCosmosIconPreviewOff } from '@cosmos/web/lib/custom-elements/cosmos-icon-preview-off';
import { defineCustomElement as defineCustomElementCosmosIconPreviewOffFilled } from '@cosmos/web/lib/custom-elements/cosmos-icon-preview-off-filled';
import { defineCustomElement as defineCustomElementCosmosIconPrinter } from '@cosmos/web/lib/custom-elements/cosmos-icon-printer';
import { defineCustomElement as defineCustomElementCosmosIconProductPlacement } from '@cosmos/web/lib/custom-elements/cosmos-icon-product-placement';
import { defineCustomElement as defineCustomElementCosmosIconPushPin } from '@cosmos/web/lib/custom-elements/cosmos-icon-push-pin';
import { defineCustomElement as defineCustomElementCosmosIconQuality } from '@cosmos/web/lib/custom-elements/cosmos-icon-quality';
import { defineCustomElement as defineCustomElementCosmosIconQuiz } from '@cosmos/web/lib/custom-elements/cosmos-icon-quiz';
import { defineCustomElement as defineCustomElementCosmosIconRadioButton } from '@cosmos/web/lib/custom-elements/cosmos-icon-radio-button';
import { defineCustomElement as defineCustomElementCosmosIconReddit } from '@cosmos/web/lib/custom-elements/cosmos-icon-reddit';
import { defineCustomElement as defineCustomElementCosmosIconRedditBranded } from '@cosmos/web/lib/custom-elements/cosmos-icon-reddit-branded';
import { defineCustomElement as defineCustomElementCosmosIconRedeem } from '@cosmos/web/lib/custom-elements/cosmos-icon-redeem';
import { defineCustomElement as defineCustomElementCosmosIconRedo } from '@cosmos/web/lib/custom-elements/cosmos-icon-redo';
import { defineCustomElement as defineCustomElementCosmosIconRelatedContent } from '@cosmos/web/lib/custom-elements/cosmos-icon-related-content';
import { defineCustomElement as defineCustomElementCosmosIconReload } from '@cosmos/web/lib/custom-elements/cosmos-icon-reload';
import { defineCustomElement as defineCustomElementCosmosIconReminderFalse } from '@cosmos/web/lib/custom-elements/cosmos-icon-reminder-false';
import { defineCustomElement as defineCustomElementCosmosIconReminderTrue } from '@cosmos/web/lib/custom-elements/cosmos-icon-reminder-true';
import { defineCustomElement as defineCustomElementCosmosIconRemove } from '@cosmos/web/lib/custom-elements/cosmos-icon-remove';
import { defineCustomElement as defineCustomElementCosmosIconRendition } from '@cosmos/web/lib/custom-elements/cosmos-icon-rendition';
import { defineCustomElement as defineCustomElementCosmosIconReplay } from '@cosmos/web/lib/custom-elements/cosmos-icon-replay';
import { defineCustomElement as defineCustomElementCosmosIconReplay30 } from '@cosmos/web/lib/custom-elements/cosmos-icon-replay-30';
import { defineCustomElement as defineCustomElementCosmosIconReplay5 } from '@cosmos/web/lib/custom-elements/cosmos-icon-replay-5';
import { defineCustomElement as defineCustomElementCosmosIconReport } from '@cosmos/web/lib/custom-elements/cosmos-icon-report';
import { defineCustomElement as defineCustomElementCosmosIconResults } from '@cosmos/web/lib/custom-elements/cosmos-icon-results';
import { defineCustomElement as defineCustomElementCosmosIconRokuReplay } from '@cosmos/web/lib/custom-elements/cosmos-icon-roku-replay';
import { defineCustomElement as defineCustomElementCosmosIconRoute } from '@cosmos/web/lib/custom-elements/cosmos-icon-route';
import { defineCustomElement as defineCustomElementCosmosIconRuler } from '@cosmos/web/lib/custom-elements/cosmos-icon-ruler';
import { defineCustomElement as defineCustomElementCosmosIconRules } from '@cosmos/web/lib/custom-elements/cosmos-icon-rules';
import { defineCustomElement as defineCustomElementCosmosIconSave } from '@cosmos/web/lib/custom-elements/cosmos-icon-save';
import { defineCustomElement as defineCustomElementCosmosIconSaveFalse } from '@cosmos/web/lib/custom-elements/cosmos-icon-save-false';
import { defineCustomElement as defineCustomElementCosmosIconSaveTrue } from '@cosmos/web/lib/custom-elements/cosmos-icon-save-true';
import { defineCustomElement as defineCustomElementCosmosIconScreenRotation } from '@cosmos/web/lib/custom-elements/cosmos-icon-screen-rotation';
import { defineCustomElement as defineCustomElementCosmosIconSearch } from '@cosmos/web/lib/custom-elements/cosmos-icon-search';
import { defineCustomElement as defineCustomElementCosmosIconSeason } from '@cosmos/web/lib/custom-elements/cosmos-icon-season';
import { defineCustomElement as defineCustomElementCosmosIconSection } from '@cosmos/web/lib/custom-elements/cosmos-icon-section';
import { defineCustomElement as defineCustomElementCosmosIconSecure } from '@cosmos/web/lib/custom-elements/cosmos-icon-secure';
import { defineCustomElement as defineCustomElementCosmosIconSelect } from '@cosmos/web/lib/custom-elements/cosmos-icon-select';
import { defineCustomElement as defineCustomElementCosmosIconSelectAll } from '@cosmos/web/lib/custom-elements/cosmos-icon-select-all';
import { defineCustomElement as defineCustomElementCosmosIconSend } from '@cosmos/web/lib/custom-elements/cosmos-icon-send';
import { defineCustomElement as defineCustomElementCosmosIconSettings } from '@cosmos/web/lib/custom-elements/cosmos-icon-settings';
import { defineCustomElement as defineCustomElementCosmosIconShare } from '@cosmos/web/lib/custom-elements/cosmos-icon-share';
import { defineCustomElement as defineCustomElementCosmosIconShareFacebook } from '@cosmos/web/lib/custom-elements/cosmos-icon-share-facebook';
import { defineCustomElement as defineCustomElementCosmosIconShareMessenger } from '@cosmos/web/lib/custom-elements/cosmos-icon-share-messenger';
import { defineCustomElement as defineCustomElementCosmosIconShareReddit } from '@cosmos/web/lib/custom-elements/cosmos-icon-share-reddit';
import { defineCustomElement as defineCustomElementCosmosIconShareTab } from '@cosmos/web/lib/custom-elements/cosmos-icon-share-tab';
import { defineCustomElement as defineCustomElementCosmosIconShareTwitterFilled } from '@cosmos/web/lib/custom-elements/cosmos-icon-share-twitter-filled';
import { defineCustomElement as defineCustomElementCosmosIconShareVk } from '@cosmos/web/lib/custom-elements/cosmos-icon-share-vk';
import { defineCustomElement as defineCustomElementCosmosIconShareWhatsapp } from '@cosmos/web/lib/custom-elements/cosmos-icon-share-whatsapp';
import { defineCustomElement as defineCustomElementCosmosIconShop } from '@cosmos/web/lib/custom-elements/cosmos-icon-shop';
import { defineCustomElement as defineCustomElementCosmosIconShoppingBag } from '@cosmos/web/lib/custom-elements/cosmos-icon-shopping-bag';
import { defineCustomElement as defineCustomElementCosmosIconShow } from '@cosmos/web/lib/custom-elements/cosmos-icon-show';
import { defineCustomElement as defineCustomElementCosmosIconSidebarOff } from '@cosmos/web/lib/custom-elements/cosmos-icon-sidebar-off';
import { defineCustomElement as defineCustomElementCosmosIconSidebarOn } from '@cosmos/web/lib/custom-elements/cosmos-icon-sidebar-on';
import { defineCustomElement as defineCustomElementCosmosIconSignIn } from '@cosmos/web/lib/custom-elements/cosmos-icon-sign-in';
import { defineCustomElement as defineCustomElementCosmosIconSignOut } from '@cosmos/web/lib/custom-elements/cosmos-icon-sign-out';
import { defineCustomElement as defineCustomElementCosmosIconSignUp } from '@cosmos/web/lib/custom-elements/cosmos-icon-sign-up';
import { defineCustomElement as defineCustomElementCosmosIconSizeContract } from '@cosmos/web/lib/custom-elements/cosmos-icon-size-contract';
import { defineCustomElement as defineCustomElementCosmosIconSizeExpand } from '@cosmos/web/lib/custom-elements/cosmos-icon-size-expand';
import { defineCustomElement as defineCustomElementCosmosIconSkipNext } from '@cosmos/web/lib/custom-elements/cosmos-icon-skip-next';
import { defineCustomElement as defineCustomElementCosmosIconSkipNextTriangle } from '@cosmos/web/lib/custom-elements/cosmos-icon-skip-next-triangle';
import { defineCustomElement as defineCustomElementCosmosIconSkipPrevious } from '@cosmos/web/lib/custom-elements/cosmos-icon-skip-previous';
import { defineCustomElement as defineCustomElementCosmosIconSkipPreviousTriangle } from '@cosmos/web/lib/custom-elements/cosmos-icon-skip-previous-triangle';
import { defineCustomElement as defineCustomElementCosmosIconSnapchat } from '@cosmos/web/lib/custom-elements/cosmos-icon-snapchat';
import { defineCustomElement as defineCustomElementCosmosIconSnapchatBrandedDark } from '@cosmos/web/lib/custom-elements/cosmos-icon-snapchat-branded-dark';
import { defineCustomElement as defineCustomElementCosmosIconSnapchatBrandedLight } from '@cosmos/web/lib/custom-elements/cosmos-icon-snapchat-branded-light';
import { defineCustomElement as defineCustomElementCosmosIconSneaker } from '@cosmos/web/lib/custom-elements/cosmos-icon-sneaker';
import { defineCustomElement as defineCustomElementCosmosIconSongkick } from '@cosmos/web/lib/custom-elements/cosmos-icon-songkick';
import { defineCustomElement as defineCustomElementCosmosIconSongkickBranded } from '@cosmos/web/lib/custom-elements/cosmos-icon-songkick-branded';
import { defineCustomElement as defineCustomElementCosmosIconSort } from '@cosmos/web/lib/custom-elements/cosmos-icon-sort';
import { defineCustomElement as defineCustomElementCosmosIconSortAZ } from '@cosmos/web/lib/custom-elements/cosmos-icon-sort-a-z';
import { defineCustomElement as defineCustomElementCosmosIconSortZA } from '@cosmos/web/lib/custom-elements/cosmos-icon-sort-z-a';
import { defineCustomElement as defineCustomElementCosmosIconSoundcloud } from '@cosmos/web/lib/custom-elements/cosmos-icon-soundcloud';
import { defineCustomElement as defineCustomElementCosmosIconSoundcloudBranded } from '@cosmos/web/lib/custom-elements/cosmos-icon-soundcloud-branded';
import { defineCustomElement as defineCustomElementCosmosIconSpotify } from '@cosmos/web/lib/custom-elements/cosmos-icon-spotify';
import { defineCustomElement as defineCustomElementCosmosIconSpotifyBranded } from '@cosmos/web/lib/custom-elements/cosmos-icon-spotify-branded';
import { defineCustomElement as defineCustomElementCosmosIconStar } from '@cosmos/web/lib/custom-elements/cosmos-icon-star';
import { defineCustomElement as defineCustomElementCosmosIconStarFilled } from '@cosmos/web/lib/custom-elements/cosmos-icon-star-filled';
import { defineCustomElement as defineCustomElementCosmosIconStarred } from '@cosmos/web/lib/custom-elements/cosmos-icon-starred';
import { defineCustomElement as defineCustomElementCosmosIconStarredFilled } from '@cosmos/web/lib/custom-elements/cosmos-icon-starred-filled';
import { defineCustomElement as defineCustomElementCosmosIconStart } from '@cosmos/web/lib/custom-elements/cosmos-icon-start';
import { defineCustomElement as defineCustomElementCosmosIconStop } from '@cosmos/web/lib/custom-elements/cosmos-icon-stop';
import { defineCustomElement as defineCustomElementCosmosIconStory } from '@cosmos/web/lib/custom-elements/cosmos-icon-story';
import { defineCustomElement as defineCustomElementCosmosIconStrava } from '@cosmos/web/lib/custom-elements/cosmos-icon-strava';
import { defineCustomElement as defineCustomElementCosmosIconStravaBranded } from '@cosmos/web/lib/custom-elements/cosmos-icon-strava-branded';
import { defineCustomElement as defineCustomElementCosmosIconSubmit } from '@cosmos/web/lib/custom-elements/cosmos-icon-submit';
import { defineCustomElement as defineCustomElementCosmosIconSubtitles } from '@cosmos/web/lib/custom-elements/cosmos-icon-subtitles';
import { defineCustomElement as defineCustomElementCosmosIconSubtitlesFilled } from '@cosmos/web/lib/custom-elements/cosmos-icon-subtitles-filled';
import { defineCustomElement as defineCustomElementCosmosIconSuccess } from '@cosmos/web/lib/custom-elements/cosmos-icon-success';
import { defineCustomElement as defineCustomElementCosmosIconTShirt } from '@cosmos/web/lib/custom-elements/cosmos-icon-t-shirt';
import { defineCustomElement as defineCustomElementCosmosIconTable } from '@cosmos/web/lib/custom-elements/cosmos-icon-table';
import { defineCustomElement as defineCustomElementCosmosIconTablet } from '@cosmos/web/lib/custom-elements/cosmos-icon-tablet';
import { defineCustomElement as defineCustomElementCosmosIconTap } from '@cosmos/web/lib/custom-elements/cosmos-icon-tap';
import { defineCustomElement as defineCustomElementCosmosIconTeam } from '@cosmos/web/lib/custom-elements/cosmos-icon-team';
import { defineCustomElement as defineCustomElementCosmosIconTextFormat } from '@cosmos/web/lib/custom-elements/cosmos-icon-text-format';
import { defineCustomElement as defineCustomElementCosmosIconThumbsDown } from '@cosmos/web/lib/custom-elements/cosmos-icon-thumbs-down';
import { defineCustomElement as defineCustomElementCosmosIconThumbsUp } from '@cosmos/web/lib/custom-elements/cosmos-icon-thumbs-up';
import { defineCustomElement as defineCustomElementCosmosIconTiktok } from '@cosmos/web/lib/custom-elements/cosmos-icon-tiktok';
import { defineCustomElement as defineCustomElementCosmosIconTiktokBrandedDark } from '@cosmos/web/lib/custom-elements/cosmos-icon-tiktok-branded-dark';
import { defineCustomElement as defineCustomElementCosmosIconTiktokBrandedLight } from '@cosmos/web/lib/custom-elements/cosmos-icon-tiktok-branded-light';
import { defineCustomElement as defineCustomElementCosmosIconTiktokDark } from '@cosmos/web/lib/custom-elements/cosmos-icon-tiktok-dark';
import { defineCustomElement as defineCustomElementCosmosIconTiktokLight } from '@cosmos/web/lib/custom-elements/cosmos-icon-tiktok-light';
import { defineCustomElement as defineCustomElementCosmosIconTrailer } from '@cosmos/web/lib/custom-elements/cosmos-icon-trailer';
import { defineCustomElement as defineCustomElementCosmosIconTranslate } from '@cosmos/web/lib/custom-elements/cosmos-icon-translate';
import { defineCustomElement as defineCustomElementCosmosIconTranslateAlt } from '@cosmos/web/lib/custom-elements/cosmos-icon-translate-alt';
import { defineCustomElement as defineCustomElementCosmosIconTrending } from '@cosmos/web/lib/custom-elements/cosmos-icon-trending';
import { defineCustomElement as defineCustomElementCosmosIconTrophy } from '@cosmos/web/lib/custom-elements/cosmos-icon-trophy';
import { defineCustomElement as defineCustomElementCosmosIconTv } from '@cosmos/web/lib/custom-elements/cosmos-icon-tv';
import { defineCustomElement as defineCustomElementCosmosIconTwitch } from '@cosmos/web/lib/custom-elements/cosmos-icon-twitch';
import { defineCustomElement as defineCustomElementCosmosIconTwitchBranded } from '@cosmos/web/lib/custom-elements/cosmos-icon-twitch-branded';
import { defineCustomElement as defineCustomElementCosmosIconUndo } from '@cosmos/web/lib/custom-elements/cosmos-icon-undo';
import { defineCustomElement as defineCustomElementCosmosIconUpload } from '@cosmos/web/lib/custom-elements/cosmos-icon-upload';
import { defineCustomElement as defineCustomElementCosmosIconUser } from '@cosmos/web/lib/custom-elements/cosmos-icon-user';
import { defineCustomElement as defineCustomElementCosmosIconUserFilled } from '@cosmos/web/lib/custom-elements/cosmos-icon-user-filled';
import { defineCustomElement as defineCustomElementCosmosIconUserSettings } from '@cosmos/web/lib/custom-elements/cosmos-icon-user-settings';
import { defineCustomElement as defineCustomElementCosmosIconVerified } from '@cosmos/web/lib/custom-elements/cosmos-icon-verified';
import { defineCustomElement as defineCustomElementCosmosIconVideo } from '@cosmos/web/lib/custom-elements/cosmos-icon-video';
import { defineCustomElement as defineCustomElementCosmosIconViewMore } from '@cosmos/web/lib/custom-elements/cosmos-icon-view-more';
import { defineCustomElement as defineCustomElementCosmosIconVimeo } from '@cosmos/web/lib/custom-elements/cosmos-icon-vimeo';
import { defineCustomElement as defineCustomElementCosmosIconVimeoBranded } from '@cosmos/web/lib/custom-elements/cosmos-icon-vimeo-branded';
import { defineCustomElement as defineCustomElementCosmosIconVine } from '@cosmos/web/lib/custom-elements/cosmos-icon-vine';
import { defineCustomElement as defineCustomElementCosmosIconVk } from '@cosmos/web/lib/custom-elements/cosmos-icon-vk';
import { defineCustomElement as defineCustomElementCosmosIconVkBranded } from '@cosmos/web/lib/custom-elements/cosmos-icon-vk-branded';
import { defineCustomElement as defineCustomElementCosmosIconVolume } from '@cosmos/web/lib/custom-elements/cosmos-icon-volume';
import { defineCustomElement as defineCustomElementCosmosIconVolumeDown } from '@cosmos/web/lib/custom-elements/cosmos-icon-volume-down';
import { defineCustomElement as defineCustomElementCosmosIconVolumeLow } from '@cosmos/web/lib/custom-elements/cosmos-icon-volume-low';
import { defineCustomElement as defineCustomElementCosmosIconVolumeMid } from '@cosmos/web/lib/custom-elements/cosmos-icon-volume-mid';
import { defineCustomElement as defineCustomElementCosmosIconVolumeUp } from '@cosmos/web/lib/custom-elements/cosmos-icon-volume-up';
import { defineCustomElement as defineCustomElementCosmosIconVote } from '@cosmos/web/lib/custom-elements/cosmos-icon-vote';
import { defineCustomElement as defineCustomElementCosmosIconVr } from '@cosmos/web/lib/custom-elements/cosmos-icon-vr';
import { defineCustomElement as defineCustomElementCosmosIconWarehouse } from '@cosmos/web/lib/custom-elements/cosmos-icon-warehouse';
import { defineCustomElement as defineCustomElementCosmosIconWarning } from '@cosmos/web/lib/custom-elements/cosmos-icon-warning';
import { defineCustomElement as defineCustomElementCosmosIconWashout } from '@cosmos/web/lib/custom-elements/cosmos-icon-washout';
import { defineCustomElement as defineCustomElementCosmosIconWatch } from '@cosmos/web/lib/custom-elements/cosmos-icon-watch';
import { defineCustomElement as defineCustomElementCosmosIconWeather } from '@cosmos/web/lib/custom-elements/cosmos-icon-weather';
import { defineCustomElement as defineCustomElementCosmosIconWhatsapp } from '@cosmos/web/lib/custom-elements/cosmos-icon-whatsapp';
import { defineCustomElement as defineCustomElementCosmosIconWhatsappBranded } from '@cosmos/web/lib/custom-elements/cosmos-icon-whatsapp-branded';
import { defineCustomElement as defineCustomElementCosmosIconX } from '@cosmos/web/lib/custom-elements/cosmos-icon-x';
import { defineCustomElement as defineCustomElementCosmosIconXBrandedDark } from '@cosmos/web/lib/custom-elements/cosmos-icon-x-branded-dark';
import { defineCustomElement as defineCustomElementCosmosIconXBrandedLight } from '@cosmos/web/lib/custom-elements/cosmos-icon-x-branded-light';
import { defineCustomElement as defineCustomElementCosmosIconYoutube } from '@cosmos/web/lib/custom-elements/cosmos-icon-youtube';
import { defineCustomElement as defineCustomElementCosmosIconYoutubeBranded } from '@cosmos/web/lib/custom-elements/cosmos-icon-youtube-branded';
import { defineCustomElement as defineCustomElementCosmosIconZoomIn } from '@cosmos/web/lib/custom-elements/cosmos-icon-zoom-in';
import { defineCustomElement as defineCustomElementCosmosIconZoomOut } from '@cosmos/web/lib/custom-elements/cosmos-icon-zoom-out';
import { defineCustomElement as defineCustomElementCosmosImage } from '@cosmos/web/lib/custom-elements/cosmos-image';
import { defineCustomElement as defineCustomElementCosmosInput } from '@cosmos/web/lib/custom-elements/cosmos-input';
import { defineCustomElement as defineCustomElementCosmosLink } from '@cosmos/web/lib/custom-elements/cosmos-link';
import { defineCustomElement as defineCustomElementCosmosLinkCard } from '@cosmos/web/lib/custom-elements/cosmos-link-card';
import { defineCustomElement as defineCustomElementCosmosLinkItem } from '@cosmos/web/lib/custom-elements/cosmos-link-item';
import { defineCustomElement as defineCustomElementCosmosMediaPreview } from '@cosmos/web/lib/custom-elements/cosmos-media-preview';
import { defineCustomElement as defineCustomElementCosmosMode } from '@cosmos/web/lib/custom-elements/cosmos-mode';
import { defineCustomElement as defineCustomElementCosmosOptgroup } from '@cosmos/web/lib/custom-elements/cosmos-optgroup';
import { defineCustomElement as defineCustomElementCosmosOption } from '@cosmos/web/lib/custom-elements/cosmos-option';
import { defineCustomElement as defineCustomElementCosmosPersonCard } from '@cosmos/web/lib/custom-elements/cosmos-person-card';
import { defineCustomElement as defineCustomElementCosmosPersonItem } from '@cosmos/web/lib/custom-elements/cosmos-person-item';
import { defineCustomElement as defineCustomElementCosmosProductCard } from '@cosmos/web/lib/custom-elements/cosmos-product-card';
import { defineCustomElement as defineCustomElementCosmosProductItem } from '@cosmos/web/lib/custom-elements/cosmos-product-item';
import { defineCustomElement as defineCustomElementCosmosRadio } from '@cosmos/web/lib/custom-elements/cosmos-radio';
import { defineCustomElement as defineCustomElementCosmosRadioGroup } from '@cosmos/web/lib/custom-elements/cosmos-radio-group';
import { defineCustomElement as defineCustomElementCosmosSelect } from '@cosmos/web/lib/custom-elements/cosmos-select';
import { defineCustomElement as defineCustomElementCosmosSelectValue } from '@cosmos/web/lib/custom-elements/cosmos-select-value';
import { defineCustomElement as defineCustomElementCosmosSpinner } from '@cosmos/web/lib/custom-elements/cosmos-spinner';
import { defineCustomElement as defineCustomElementCosmosStoryCard } from '@cosmos/web/lib/custom-elements/cosmos-story-card';
import { defineCustomElement as defineCustomElementCosmosStoryItem } from '@cosmos/web/lib/custom-elements/cosmos-story-item';
import { defineCustomElement as defineCustomElementCosmosText } from '@cosmos/web/lib/custom-elements/cosmos-text';
import { defineCustomElement as defineCustomElementCosmosTextarea } from '@cosmos/web/lib/custom-elements/cosmos-textarea';
import { defineCustomElement as defineCustomElementCosmosTitle } from '@cosmos/web/lib/custom-elements/cosmos-title';
import { defineCustomElement as defineCustomElementCosmosTooltip } from '@cosmos/web/lib/custom-elements/cosmos-tooltip';
import { defineCustomElement as defineCustomElementCosmosVideoCard } from '@cosmos/web/lib/custom-elements/cosmos-video-card';
import { defineCustomElement as defineCustomElementCosmosVideoItem } from '@cosmos/web/lib/custom-elements/cosmos-video-item';
import { defineCustomElement as defineCustomElementDeprecatedComponent } from '@cosmos/web/lib/custom-elements/deprecated-component';
export const CosmosAssetItemBase = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-asset-item-base',
    defaultProps: { metaTextPrimaryClamp: false, metaTextSecondaryClamp: false, size: 'small' },
    defineCustomElement: defineCustomElementCosmosAssetItemBase
});
export const CosmosAvatar = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-avatar',
    defaultProps: { alt: '', framed: false, loading: 'eager', size: 'medium' },
    defineCustomElement: defineCustomElementCosmosAvatar
});
export const CosmosBadge = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-badge',
    defaultProps: { kind: 'primary', shape: 'pill', size: 'medium' },
    defineCustomElement: defineCustomElementCosmosBadge
});
export const CosmosButton = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-button',
    defaultProps: { busy: false, decorative: false, disabled: false, hovered: false, href: undefined, iconPlacement: 'before', kind: 'primary', size: 'medium', type: 'button', width: 'content' },
    defineCustomElement: defineCustomElementCosmosButton
});
export const CosmosCheckbox = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-checkbox',
    defaultProps: { checked: false, hitArea: 'content', invalid: false, required: false },
    defineCustomElement: defineCustomElementCosmosCheckbox
});
export const CosmosCheckboxGroup = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-checkbox-group',
    defaultProps: { invalid: false },
    defineCustomElement: defineCustomElementCosmosCheckboxGroup
});
export const CosmosChip = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-chip',
    defaultProps: { shape: 'pill' },
    defineCustomElement: defineCustomElementCosmosChip
});
export const CosmosDefaultCard = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-default-card',
    defaultProps: { cover: false, favoritable: false, favorited: false, layout: 'normal', logoAlt: '' },
    defineCustomElement: defineCustomElementCosmosDefaultCard
});
export const CosmosDefaultItem = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-default-item',
    defaultProps: { metaTextPrimaryClamp: 1, metaTextSecondaryClamp: 1, size: 'small' },
    defineCustomElement: defineCustomElementCosmosDefaultItem
});
export const CosmosFlag = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-flag',
    defaultProps: { alt: '', loading: 'eager' },
    defineCustomElement: defineCustomElementCosmosFlag
});
export const CosmosIcon = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIcon
});
export const CosmosIcon360Photo = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-360-photo',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIcon360Photo
});
export const CosmosIcon360Video = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-360-video',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIcon360Video
});
export const CosmosIconAdd = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-add',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconAdd
});
export const CosmosIconAirplay = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-airplay',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconAirplay
});
export const CosmosIconAlignCenter = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-align-center',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconAlignCenter
});
export const CosmosIconAlignLeft = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-align-left',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconAlignLeft
});
export const CosmosIconAlignRight = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-align-right',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconAlignRight
});
export const CosmosIconAmazon = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-amazon',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconAmazon
});
export const CosmosIconAmazonBrandedDark = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-amazon-branded-dark',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconAmazonBrandedDark
});
export const CosmosIconAmazonBrandedLight = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-amazon-branded-light',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconAmazonBrandedLight
});
export const CosmosIconAmazonMusic = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-amazon-music',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconAmazonMusic
});
export const CosmosIconAmazonMusicBranded = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-amazon-music-branded',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconAmazonMusicBranded
});
export const CosmosIconApple = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-apple',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconApple
});
export const CosmosIconApplePodcasts = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-apple-podcasts',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconApplePodcasts
});
export const CosmosIconApplePodcastsBranded = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-apple-podcasts-branded',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconApplePodcastsBranded
});
export const CosmosIconAr = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-ar',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconAr
});
export const CosmosIconArActive = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-ar-active',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconArActive
});
export const CosmosIconArLabel = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-ar-label',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconArLabel
});
export const CosmosIconArMobile = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-ar-mobile',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconArMobile
});
export const CosmosIconArchive = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-archive',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconArchive
});
export const CosmosIconArrowDiagonalDownLeft = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-arrow-diagonal-down-left',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconArrowDiagonalDownLeft
});
export const CosmosIconArrowDiagonalDownRight = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-arrow-diagonal-down-right',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconArrowDiagonalDownRight
});
export const CosmosIconArrowDiagonalUpLeft = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-arrow-diagonal-up-left',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconArrowDiagonalUpLeft
});
export const CosmosIconArrowDiagonalUpRight = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-arrow-diagonal-up-right',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconArrowDiagonalUpRight
});
export const CosmosIconArrowDown = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-arrow-down',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconArrowDown
});
export const CosmosIconArrowDownUp = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-arrow-down-up',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconArrowDownUp
});
export const CosmosIconArrowLeft = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-arrow-left',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconArrowLeft
});
export const CosmosIconArrowReturnLeft = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-arrow-return-left',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconArrowReturnLeft
});
export const CosmosIconArrowReturnRight = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-arrow-return-right',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconArrowReturnRight
});
export const CosmosIconArrowRight = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-arrow-right',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconArrowRight
});
export const CosmosIconArrowTriangleLeft = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-arrow-triangle-left',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconArrowTriangleLeft
});
export const CosmosIconArrowTriangleRight = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-arrow-triangle-right',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconArrowTriangleRight
});
export const CosmosIconArrowUp = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-arrow-up',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconArrowUp
});
export const CosmosIconAuthor = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-author',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconAuthor
});
export const CosmosIconBack = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-back',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconBack
});
export const CosmosIconBack10 = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-back-10',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconBack10
});
export const CosmosIconBack15 = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-back-15',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconBack15
});
export const CosmosIconBack20 = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-back-20',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconBack20
});
export const CosmosIconBackward = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-backward',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconBackward
});
export const CosmosIconBandsintown = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-bandsintown',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconBandsintown
});
export const CosmosIconBandsintownBranded = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-bandsintown-branded',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconBandsintownBranded
});
export const CosmosIconBaseballCap = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-baseball-cap',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconBaseballCap
});
export const CosmosIconBookmark = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-bookmark',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconBookmark
});
export const CosmosIconBookmarkFilled = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-bookmark-filled',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconBookmarkFilled
});
export const CosmosIconBrowse = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-browse',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconBrowse
});
export const CosmosIconBrowseFilled = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-browse-filled',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconBrowseFilled
});
export const CosmosIconBulb = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-bulb',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconBulb
});
export const CosmosIconBulbFilled = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-bulb-filled',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconBulbFilled
});
export const CosmosIconBuyTickets = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-buy-tickets',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconBuyTickets
});
export const CosmosIconCalendar = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-calendar',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconCalendar
});
export const CosmosIconCalendarFilled = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-calendar-filled',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconCalendarFilled
});
export const CosmosIconCan = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-can',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconCan
});
export const CosmosIconCanInverted = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-can-inverted',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconCanInverted
});
export const CosmosIconCancel = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-cancel',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconCancel
});
export const CosmosIconCaptions = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-captions',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconCaptions
});
export const CosmosIconCaptionsFilled = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-captions-filled',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconCaptionsFilled
});
export const CosmosIconCaretDown = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-caret-down',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconCaretDown
});
export const CosmosIconCaretLeft = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-caret-left',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconCaretLeft
});
export const CosmosIconCaretRight = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-caret-right',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconCaretRight
});
export const CosmosIconCaretUp = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-caret-up',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconCaretUp
});
export const CosmosIconChatAdd = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-chat-add',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconChatAdd
});
export const CosmosIconCheckboxChecked = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-checkbox-checked',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconCheckboxChecked
});
export const CosmosIconCheckboxUnchecked = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-checkbox-unchecked',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconCheckboxUnchecked
});
export const CosmosIconCheckmark = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-checkmark',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconCheckmark
});
export const CosmosIconCheckout = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-checkout',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconCheckout
});
export const CosmosIconChevronDown = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-chevron-down',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconChevronDown
});
export const CosmosIconChevronLeft = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-chevron-left',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconChevronLeft
});
export const CosmosIconChevronRight = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-chevron-right',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconChevronRight
});
export const CosmosIconChevronUp = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-chevron-up',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconChevronUp
});
export const CosmosIconChromecast = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-chromecast',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconChromecast
});
export const CosmosIconChromecastFilled = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-chromecast-filled',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconChromecastFilled
});
export const CosmosIconClear = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-clear',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconClear
});
export const CosmosIconClip = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-clip',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconClip
});
export const CosmosIconClock = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-clock',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconClock
});
export const CosmosIconClose = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-close',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconClose
});
export const CosmosIconCloseSmall = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-close-small',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconCloseSmall
});
export const CosmosIconCloud = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-cloud',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconCloud
});
export const CosmosIconCodeBlock = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-code-block',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconCodeBlock
});
export const CosmosIconCollapse = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-collapse',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconCollapse
});
export const CosmosIconCollapseArrows = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-collapse-arrows',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconCollapseArrows
});
export const CosmosIconCollapseHorizontal = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-collapse-horizontal',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconCollapseHorizontal
});
export const CosmosIconCollapseVertical = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-collapse-vertical',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconCollapseVertical
});
export const CosmosIconColumns = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-columns',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconColumns
});
export const CosmosIconComment = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-comment',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconComment
});
export const CosmosIconContextual = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-contextual',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconContextual
});
export const CosmosIconContract = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-contract',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconContract
});
export const CosmosIconCopyLink = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-copy-link',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconCopyLink
});
export const CosmosIconCountry = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-country',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconCountry
});
export const CosmosIconCouple = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-couple',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconCouple
});
export const CosmosIconCrashed = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-crashed',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconCrashed
});
export const CosmosIconCreate = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-create',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconCreate
});
export const CosmosIconCrew = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-crew',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconCrew
});
export const CosmosIconCrop = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-crop',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconCrop
});
export const CosmosIconCurrency = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-currency',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconCurrency
});
export const CosmosIconCurrentlyWatching = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-currently-watching',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconCurrentlyWatching
});
export const CosmosIconCut = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-cut',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconCut
});
export const CosmosIconDeezer = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-deezer',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconDeezer
});
export const CosmosIconDeezerBranded = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-deezer-branded',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconDeezerBranded
});
export const CosmosIconDelete = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-delete',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconDelete
});
export const CosmosIconDelivery = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-delivery',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconDelivery
});
export const CosmosIconDesktop = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-desktop',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconDesktop
});
export const CosmosIconDevices = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-devices',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconDevices
});
export const CosmosIconDirections = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-directions',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconDirections
});
export const CosmosIconDiscover = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-discover',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconDiscover
});
export const CosmosIconDocumentFiling = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-document-filing',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconDocumentFiling
});
export const CosmosIconDocumentFiling2 = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-document-filing-2',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconDocumentFiling2
});
export const CosmosIconDocumentFilled = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-document-filled',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconDocumentFilled
});
export const CosmosIconDownload = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-download',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconDownload
});
export const CosmosIconDownloadError = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-download-error',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconDownloadError
});
export const CosmosIconDownloading = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-downloading',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconDownloading
});
export const CosmosIconDragHandleHorizontal = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-drag-handle-horizontal',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconDragHandleHorizontal
});
export const CosmosIconDragHandleVertical = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-drag-handle-vertical',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconDragHandleVertical
});
export const CosmosIconDrink = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-drink',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconDrink
});
export const CosmosIconDuplicate = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-duplicate',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconDuplicate
});
export const CosmosIconEdit = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-edit',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconEdit
});
export const CosmosIconEmail = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-email',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconEmail
});
export const CosmosIconEmoji = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-emoji',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconEmoji
});
export const CosmosIconEnlarge = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-enlarge',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconEnlarge
});
export const CosmosIconEnvelopeFilled = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-envelope-filled',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconEnvelopeFilled
});
export const CosmosIconEpg = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-epg',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconEpg
});
export const CosmosIconEpisode = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-episode',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconEpisode
});
export const CosmosIconErrorFilled = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-error-filled',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconErrorFilled
});
export const CosmosIconEvent = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-event',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconEvent
});
export const CosmosIconEventDetails = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-event-details',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconEventDetails
});
export const CosmosIconEventEnd = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-event-end',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconEventEnd
});
export const CosmosIconEventSeries = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-event-series',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconEventSeries
});
export const CosmosIconEventStart = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-event-start',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconEventStart
});
export const CosmosIconExpand = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-expand',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconExpand
});
export const CosmosIconExpandArrows = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-expand-arrows',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconExpandArrows
});
export const CosmosIconExpandHorizontal = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-expand-horizontal',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconExpandHorizontal
});
export const CosmosIconExpandLess = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-expand-less',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconExpandLess
});
export const CosmosIconExpandMore = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-expand-more',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconExpandMore
});
export const CosmosIconExpandVertical = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-expand-vertical',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconExpandVertical
});
export const CosmosIconExternalLink = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-external-link',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconExternalLink
});
export const CosmosIconFacebook = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-facebook',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconFacebook
});
export const CosmosIconFacebookBranded = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-facebook-branded',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconFacebookBranded
});
export const CosmosIconFastCheckout = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-fast-checkout',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconFastCheckout
});
export const CosmosIconFastForward = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-fast-forward',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconFastForward
});
export const CosmosIconFastRewind = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-fast-rewind',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconFastRewind
});
export const CosmosIconFeatureFilm = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-feature-film',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconFeatureFilm
});
export const CosmosIconFeedback = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-feedback',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconFeedback
});
export const CosmosIconFeedbackFilled = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-feedback-filled',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconFeedbackFilled
});
export const CosmosIconFemale = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-female',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconFemale
});
export const CosmosIconFileDownload = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-file-download',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconFileDownload
});
export const CosmosIconFileRemove = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-file-remove',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconFileRemove
});
export const CosmosIconFileUpload = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-file-upload',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconFileUpload
});
export const CosmosIconFilmCamera = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-film-camera',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconFilmCamera
});
export const CosmosIconFilms = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-films',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconFilms
});
export const CosmosIconFilter = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-filter',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconFilter
});
export const CosmosIconFilterList = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-filter-list',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconFilterList
});
export const CosmosIconFilterRemove = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-filter-remove',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconFilterRemove
});
export const CosmosIconFlag = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-flag',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconFlag
});
export const CosmosIconFolder = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-folder',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconFolder
});
export const CosmosIconFolderAdd = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-folder-add',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconFolderAdd
});
export const CosmosIconFolderDownload = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-folder-download',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconFolderDownload
});
export const CosmosIconFolderOpen = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-folder-open',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconFolderOpen
});
export const CosmosIconFolderRemove = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-folder-remove',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconFolderRemove
});
export const CosmosIconFolderShared = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-folder-shared',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconFolderShared
});
export const CosmosIconFolderUpload = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-folder-upload',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconFolderUpload
});
export const CosmosIconFormatBold = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-format-bold',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconFormatBold
});
export const CosmosIconFormatListNumbered = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-format-list-numbered',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconFormatListNumbered
});
export const CosmosIconFormatQuote = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-format-quote',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconFormatQuote
});
export const CosmosIconFormatSize = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-format-size',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconFormatSize
});
export const CosmosIconFormatUnderline = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-format-underline',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconFormatUnderline
});
export const CosmosIconForward = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-forward',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconForward
});
export const CosmosIconForward10 = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-forward-10',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconForward10
});
export const CosmosIconForward15 = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-forward-15',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconForward15
});
export const CosmosIconForward20 = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-forward-20',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconForward20
});
export const CosmosIconFullscreen = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-fullscreen',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconFullscreen
});
export const CosmosIconFullscreenExit = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-fullscreen-exit',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconFullscreenExit
});
export const CosmosIconFunnel = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-funnel',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconFunnel
});
export const CosmosIconFunnelRemove = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-funnel-remove',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconFunnelRemove
});
export const CosmosIconGallery = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-gallery',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconGallery
});
export const CosmosIconGame = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-game',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconGame
});
export const CosmosIconGenericContent = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-generic-content',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconGenericContent
});
export const CosmosIconGlobeGeo = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-globe-geo',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconGlobeGeo
});
export const CosmosIconGoogle = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-google',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconGoogle
});
export const CosmosIconGoogleBranded = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-google-branded',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconGoogleBranded
});
export const CosmosIconGooglePlay = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-google-play',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconGooglePlay
});
export const CosmosIconGooglePlayBranded = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-google-play-branded',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconGooglePlayBranded
});
export const CosmosIconGooglePodcasts = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-google-podcasts',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconGooglePodcasts
});
export const CosmosIconGooglePodcastsBranded = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-google-podcasts-branded',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconGooglePodcastsBranded
});
export const CosmosIconGrid = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-grid',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconGrid
});
export const CosmosIconGridLayout = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-grid-layout',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconGridLayout
});
export const CosmosIconGridLive = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-grid-live',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconGridLive
});
export const CosmosIconHeadline = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-headline',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconHeadline
});
export const CosmosIconHeadphones = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-headphones',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconHeadphones
});
export const CosmosIconHeart = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-heart',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconHeart
});
export const CosmosIconHeartFilled = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-heart-filled',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconHeartFilled
});
export const CosmosIconHighlights = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-highlights',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconHighlights
});
export const CosmosIconHistory = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-history',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconHistory
});
export const CosmosIconHome = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-home',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconHome
});
export const CosmosIconHomeFilled = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-home-filled',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconHomeFilled
});
export const CosmosIconHot = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-hot',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconHot
});
export const CosmosIconHourglassEmpty = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-hourglass-empty',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconHourglassEmpty
});
export const CosmosIconHourglassFull = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-hourglass-full',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconHourglassFull
});
export const CosmosIconImage = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-image',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconImage
});
export const CosmosIconImageGallery = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-image-gallery',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconImageGallery
});
export const CosmosIconImageInPicture = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-image-in-picture',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconImageInPicture
});
export const CosmosIconInProgress = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-in-progress',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconInProgress
});
export const CosmosIconInfo = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-info',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconInfo
});
export const CosmosIconInfoFilled = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-info-filled',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconInfoFilled
});
export const CosmosIconInfoHeatAnalyser = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-info-heat-analyser',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconInfoHeatAnalyser
});
export const CosmosIconInfoMulticolored = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-info-multicolored',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconInfoMulticolored
});
export const CosmosIconInfographic = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-infographic',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconInfographic
});
export const CosmosIconInstagram = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-instagram',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconInstagram
});
export const CosmosIconInstagramBranded = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-instagram-branded',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconInstagramBranded
});
export const CosmosIconInterview = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-interview',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconInterview
});
export const CosmosIconInvoice = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-invoice',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconInvoice
});
export const CosmosIconItalic = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-italic',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconItalic
});
export const CosmosIconKeyboard = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-keyboard',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconKeyboard
});
export const CosmosIconLabel = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-label',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconLabel
});
export const CosmosIconLanguage = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-language',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconLanguage
});
export const CosmosIconLaptop = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-laptop',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconLaptop
});
export const CosmosIconLaunch = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-launch',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconLaunch
});
export const CosmosIconLink = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-link',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconLink
});
export const CosmosIconLinkedin = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-linkedin',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconLinkedin
});
export const CosmosIconLinkedinBranded = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-linkedin-branded',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconLinkedinBranded
});
export const CosmosIconLinkedinLogo = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-linkedin-logo',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconLinkedinLogo
});
export const CosmosIconList = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-list',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconList
});
export const CosmosIconLive = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-live',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconLive
});
export const CosmosIconLiveBroadcast = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-live-broadcast',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconLiveBroadcast
});
export const CosmosIconLoading = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-loading',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconLoading
});
export const CosmosIconLocation = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-location',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconLocation
});
export const CosmosIconLockFilled = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-lock-filled',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconLockFilled
});
export const CosmosIconLockOpen = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-lock-open',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconLockOpen
});
export const CosmosIconMagicWand = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-magic-wand',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconMagicWand
});
export const CosmosIconMale = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-male',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconMale
});
export const CosmosIconMap = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-map',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconMap
});
export const CosmosIconMegaphone = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-megaphone',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconMegaphone
});
export const CosmosIconMenu = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-menu',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconMenu
});
export const CosmosIconMenuNotification = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-menu-notification',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconMenuNotification
});
export const CosmosIconMenuPulsating = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-menu-pulsating',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconMenuPulsating
});
export const CosmosIconMessenger = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-messenger',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconMessenger
});
export const CosmosIconMessengerBranded = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-messenger-branded',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconMessengerBranded
});
export const CosmosIconMinus = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-minus',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconMinus
});
export const CosmosIconMixer = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-mixer',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconMixer
});
export const CosmosIconModeDark = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-mode-dark',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconModeDark
});
export const CosmosIconModeLight = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-mode-light',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconModeLight
});
export const CosmosIconMore = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-more',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconMore
});
export const CosmosIconMountain = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-mountain',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconMountain
});
export const CosmosIconMouse = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-mouse',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconMouse
});
export const CosmosIconMultiLanguage = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-multi-language',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconMultiLanguage
});
export const CosmosIconMute = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-mute',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconMute
});
export const CosmosIconMyLocation = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-my-location',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconMyLocation
});
export const CosmosIconNews = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-news',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconNews
});
export const CosmosIconNoConnection = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-no-connection',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconNoConnection
});
export const CosmosIconNoData = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-no-data',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconNoData
});
export const CosmosIconPagination = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-pagination',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconPagination
});
export const CosmosIconPaginationFilled = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-pagination-filled',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconPaginationFilled
});
export const CosmosIconParcel = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-parcel',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconParcel
});
export const CosmosIconPartnerProfile = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-partner-profile',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconPartnerProfile
});
export const CosmosIconPaste = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-paste',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconPaste
});
export const CosmosIconPause = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-pause',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconPause
});
export const CosmosIconPayment = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-payment',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconPayment
});
export const CosmosIconPen = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-pen',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconPen
});
export const CosmosIconPersonFollow = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-person-follow',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconPersonFollow
});
export const CosmosIconPersonFollowing = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-person-following',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconPersonFollowing
});
export const CosmosIconPersonProfileFilled = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-person-profile-filled',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconPersonProfileFilled
});
export const CosmosIconPhone = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-phone',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconPhone
});
export const CosmosIconPhotoCamera = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-photo-camera',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconPhotoCamera
});
export const CosmosIconPhotoCameraReverse = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-photo-camera-reverse',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconPhotoCameraReverse
});
export const CosmosIconPictureInPicture = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-picture-in-picture',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconPictureInPicture
});
export const CosmosIconPieOutline = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-pie-outline',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconPieOutline
});
export const CosmosIconPinterest = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-pinterest',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconPinterest
});
export const CosmosIconPinterestBranded = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-pinterest-branded',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconPinterestBranded
});
export const CosmosIconPlay = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-play',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconPlay
});
export const CosmosIconPlaylist = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-playlist',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconPlaylist
});
export const CosmosIconPlaylistPersonalised = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-playlist-personalised',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconPlaylistPersonalised
});
export const CosmosIconPlus = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-plus',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconPlus
});
export const CosmosIconPodcast = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-podcast',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconPodcast
});
export const CosmosIconPresentation = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-presentation',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconPresentation
});
export const CosmosIconPreview = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-preview',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconPreview
});
export const CosmosIconPreviewFilled = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-preview-filled',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconPreviewFilled
});
export const CosmosIconPreviewOff = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-preview-off',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconPreviewOff
});
export const CosmosIconPreviewOffFilled = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-preview-off-filled',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconPreviewOffFilled
});
export const CosmosIconPrinter = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-printer',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconPrinter
});
export const CosmosIconProductPlacement = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-product-placement',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconProductPlacement
});
export const CosmosIconPushPin = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-push-pin',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconPushPin
});
export const CosmosIconQuality = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-quality',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconQuality
});
export const CosmosIconQuiz = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-quiz',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconQuiz
});
export const CosmosIconRadioButton = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-radio-button',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconRadioButton
});
export const CosmosIconReddit = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-reddit',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconReddit
});
export const CosmosIconRedditBranded = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-reddit-branded',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconRedditBranded
});
export const CosmosIconRedeem = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-redeem',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconRedeem
});
export const CosmosIconRedo = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-redo',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconRedo
});
export const CosmosIconRelatedContent = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-related-content',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconRelatedContent
});
export const CosmosIconReload = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-reload',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconReload
});
export const CosmosIconReminderFalse = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-reminder-false',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconReminderFalse
});
export const CosmosIconReminderTrue = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-reminder-true',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconReminderTrue
});
export const CosmosIconRemove = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-remove',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconRemove
});
export const CosmosIconRendition = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-rendition',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconRendition
});
export const CosmosIconReplay = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-replay',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconReplay
});
export const CosmosIconReplay30 = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-replay-30',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconReplay30
});
export const CosmosIconReplay5 = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-replay-5',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconReplay5
});
export const CosmosIconReport = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-report',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconReport
});
export const CosmosIconResults = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-results',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconResults
});
export const CosmosIconRokuReplay = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-roku-replay',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconRokuReplay
});
export const CosmosIconRoute = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-route',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconRoute
});
export const CosmosIconRuler = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-ruler',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconRuler
});
export const CosmosIconRules = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-rules',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconRules
});
export const CosmosIconSave = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-save',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconSave
});
export const CosmosIconSaveFalse = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-save-false',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconSaveFalse
});
export const CosmosIconSaveTrue = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-save-true',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconSaveTrue
});
export const CosmosIconScreenRotation = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-screen-rotation',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconScreenRotation
});
export const CosmosIconSearch = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-search',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconSearch
});
export const CosmosIconSeason = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-season',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconSeason
});
export const CosmosIconSection = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-section',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconSection
});
export const CosmosIconSecure = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-secure',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconSecure
});
export const CosmosIconSelect = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-select',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconSelect
});
export const CosmosIconSelectAll = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-select-all',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconSelectAll
});
export const CosmosIconSend = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-send',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconSend
});
export const CosmosIconSettings = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-settings',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconSettings
});
export const CosmosIconShare = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-share',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconShare
});
export const CosmosIconShareFacebook = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-share-facebook',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconShareFacebook
});
export const CosmosIconShareMessenger = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-share-messenger',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconShareMessenger
});
export const CosmosIconShareReddit = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-share-reddit',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconShareReddit
});
export const CosmosIconShareTab = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-share-tab',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconShareTab
});
export const CosmosIconShareTwitterFilled = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-share-twitter-filled',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconShareTwitterFilled
});
export const CosmosIconShareVk = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-share-vk',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconShareVk
});
export const CosmosIconShareWhatsapp = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-share-whatsapp',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconShareWhatsapp
});
export const CosmosIconShop = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-shop',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconShop
});
export const CosmosIconShoppingBag = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-shopping-bag',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconShoppingBag
});
export const CosmosIconShow = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-show',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconShow
});
export const CosmosIconSidebarOff = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-sidebar-off',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconSidebarOff
});
export const CosmosIconSidebarOn = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-sidebar-on',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconSidebarOn
});
export const CosmosIconSignIn = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-sign-in',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconSignIn
});
export const CosmosIconSignOut = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-sign-out',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconSignOut
});
export const CosmosIconSignUp = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-sign-up',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconSignUp
});
export const CosmosIconSizeContract = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-size-contract',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconSizeContract
});
export const CosmosIconSizeExpand = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-size-expand',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconSizeExpand
});
export const CosmosIconSkipNext = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-skip-next',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconSkipNext
});
export const CosmosIconSkipNextTriangle = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-skip-next-triangle',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconSkipNextTriangle
});
export const CosmosIconSkipPrevious = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-skip-previous',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconSkipPrevious
});
export const CosmosIconSkipPreviousTriangle = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-skip-previous-triangle',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconSkipPreviousTriangle
});
export const CosmosIconSnapchat = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-snapchat',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconSnapchat
});
export const CosmosIconSnapchatBrandedDark = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-snapchat-branded-dark',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconSnapchatBrandedDark
});
export const CosmosIconSnapchatBrandedLight = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-snapchat-branded-light',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconSnapchatBrandedLight
});
export const CosmosIconSneaker = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-sneaker',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconSneaker
});
export const CosmosIconSongkick = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-songkick',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconSongkick
});
export const CosmosIconSongkickBranded = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-songkick-branded',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconSongkickBranded
});
export const CosmosIconSort = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-sort',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconSort
});
export const CosmosIconSortAZ = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-sort-a-z',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconSortAZ
});
export const CosmosIconSortZA = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-sort-z-a',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconSortZA
});
export const CosmosIconSoundcloud = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-soundcloud',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconSoundcloud
});
export const CosmosIconSoundcloudBranded = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-soundcloud-branded',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconSoundcloudBranded
});
export const CosmosIconSpotify = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-spotify',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconSpotify
});
export const CosmosIconSpotifyBranded = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-spotify-branded',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconSpotifyBranded
});
export const CosmosIconStar = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-star',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconStar
});
export const CosmosIconStarFilled = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-star-filled',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconStarFilled
});
export const CosmosIconStarred = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-starred',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconStarred
});
export const CosmosIconStarredFilled = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-starred-filled',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconStarredFilled
});
export const CosmosIconStart = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-start',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconStart
});
export const CosmosIconStop = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-stop',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconStop
});
export const CosmosIconStory = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-story',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconStory
});
export const CosmosIconStrava = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-strava',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconStrava
});
export const CosmosIconStravaBranded = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-strava-branded',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconStravaBranded
});
export const CosmosIconSubmit = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-submit',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconSubmit
});
export const CosmosIconSubtitles = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-subtitles',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconSubtitles
});
export const CosmosIconSubtitlesFilled = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-subtitles-filled',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconSubtitlesFilled
});
export const CosmosIconSuccess = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-success',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconSuccess
});
export const CosmosIconTShirt = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-t-shirt',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconTShirt
});
export const CosmosIconTable = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-table',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconTable
});
export const CosmosIconTablet = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-tablet',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconTablet
});
export const CosmosIconTap = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-tap',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconTap
});
export const CosmosIconTeam = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-team',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconTeam
});
export const CosmosIconTextFormat = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-text-format',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconTextFormat
});
export const CosmosIconThumbsDown = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-thumbs-down',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconThumbsDown
});
export const CosmosIconThumbsUp = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-thumbs-up',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconThumbsUp
});
export const CosmosIconTiktok = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-tiktok',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconTiktok
});
export const CosmosIconTiktokBrandedDark = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-tiktok-branded-dark',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconTiktokBrandedDark
});
export const CosmosIconTiktokBrandedLight = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-tiktok-branded-light',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconTiktokBrandedLight
});
export const CosmosIconTiktokDark = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-tiktok-dark',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconTiktokDark
});
export const CosmosIconTiktokLight = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-tiktok-light',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconTiktokLight
});
export const CosmosIconTrailer = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-trailer',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconTrailer
});
export const CosmosIconTranslate = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-translate',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconTranslate
});
export const CosmosIconTranslateAlt = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-translate-alt',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconTranslateAlt
});
export const CosmosIconTrending = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-trending',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconTrending
});
export const CosmosIconTrophy = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-trophy',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconTrophy
});
export const CosmosIconTv = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-tv',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconTv
});
export const CosmosIconTwitch = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-twitch',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconTwitch
});
export const CosmosIconTwitchBranded = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-twitch-branded',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconTwitchBranded
});
export const CosmosIconUndo = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-undo',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconUndo
});
export const CosmosIconUpload = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-upload',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconUpload
});
export const CosmosIconUser = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-user',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconUser
});
export const CosmosIconUserFilled = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-user-filled',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconUserFilled
});
export const CosmosIconUserSettings = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-user-settings',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconUserSettings
});
export const CosmosIconVerified = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-verified',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconVerified
});
export const CosmosIconVideo = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-video',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconVideo
});
export const CosmosIconViewMore = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-view-more',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconViewMore
});
export const CosmosIconVimeo = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-vimeo',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconVimeo
});
export const CosmosIconVimeoBranded = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-vimeo-branded',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconVimeoBranded
});
export const CosmosIconVine = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-vine',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconVine
});
export const CosmosIconVk = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-vk',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconVk
});
export const CosmosIconVkBranded = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-vk-branded',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconVkBranded
});
export const CosmosIconVolume = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-volume',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconVolume
});
export const CosmosIconVolumeDown = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-volume-down',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconVolumeDown
});
export const CosmosIconVolumeLow = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-volume-low',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconVolumeLow
});
export const CosmosIconVolumeMid = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-volume-mid',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconVolumeMid
});
export const CosmosIconVolumeUp = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-volume-up',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconVolumeUp
});
export const CosmosIconVote = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-vote',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconVote
});
export const CosmosIconVr = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-vr',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconVr
});
export const CosmosIconWarehouse = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-warehouse',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconWarehouse
});
export const CosmosIconWarning = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-warning',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconWarning
});
export const CosmosIconWashout = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-washout',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconWashout
});
export const CosmosIconWatch = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-watch',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconWatch
});
export const CosmosIconWeather = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-weather',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconWeather
});
export const CosmosIconWhatsapp = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-whatsapp',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconWhatsapp
});
export const CosmosIconWhatsappBranded = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-whatsapp-branded',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconWhatsappBranded
});
export const CosmosIconX = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-x',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconX
});
export const CosmosIconXBrandedDark = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-x-branded-dark',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconXBrandedDark
});
export const CosmosIconXBrandedLight = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-x-branded-light',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconXBrandedLight
});
export const CosmosIconYoutube = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-youtube',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconYoutube
});
export const CosmosIconYoutubeBranded = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-youtube-branded',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconYoutubeBranded
});
export const CosmosIconZoomIn = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-zoom-in',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconZoomIn
});
export const CosmosIconZoomOut = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-icon-zoom-out',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosIconZoomOut
});
export const CosmosImage = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-image',
    defaultProps: { fit: 'cover', imageAlt: '', radius: 'none' },
    defineCustomElement: defineCustomElementCosmosImage
});
export const CosmosInput = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-input',
    defaultProps: { clearable: false, disabled: false, iconPlacement: 'before', invalid: false, readonly: false, required: false, type: 'text' },
    defineCustomElement: defineCustomElementCosmosInput
});
export const CosmosLink = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-link',
    defaultProps: { kind: 'underlined' },
    defineCustomElement: defineCustomElementCosmosLink
});
export const CosmosLinkCard = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-link-card',
    defaultProps: { layout: 'normal', logoAlt: '', logoNarrow: false },
    defineCustomElement: defineCustomElementCosmosLinkCard
});
export const CosmosLinkItem = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-link-item',
    defaultProps: { size: 'small' },
    defineCustomElement: defineCustomElementCosmosLinkItem
});
export const CosmosMediaPreview = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-media-preview',
    defaultProps: { radius: 'none' },
    defineCustomElement: defineCustomElementCosmosMediaPreview
});
export const CosmosMode = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-mode',
    defaultProps: { mode: 'light' },
    defineCustomElement: defineCustomElementCosmosMode
});
export const CosmosOptgroup = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-optgroup',
    defaultProps: { appearance: 'dark' },
    defineCustomElement: defineCustomElementCosmosOptgroup
});
export const CosmosOption = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-option',
    defaultProps: { appearance: 'dark', disabled: false, selected: false, value: '' },
    defineCustomElement: defineCustomElementCosmosOption
});
export const CosmosPersonCard = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-person-card',
    defaultProps: { external: false, favoritable: false, favorited: false, layout: 'normal' },
    defineCustomElement: defineCustomElementCosmosPersonCard
});
export const CosmosPersonItem = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-person-item',
    defaultProps: { profileImageFramed: false, size: 'small' },
    defineCustomElement: defineCustomElementCosmosPersonItem
});
export const CosmosProductCard = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-product-card',
    defaultProps: { layout: 'normal', logoAlt: '' },
    defineCustomElement: defineCustomElementCosmosProductCard
});
export const CosmosProductItem = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-product-item',
    defaultProps: { size: 'small' },
    defineCustomElement: defineCustomElementCosmosProductItem
});
export const CosmosRadio = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-radio',
    defaultProps: { checked: false, disabled: false, focusable: true, hitArea: 'content', invalid: false, required: false },
    defineCustomElement: defineCustomElementCosmosRadio
});
export const CosmosRadioGroup = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-radio-group',
    defaultProps: { invalid: false },
    defineCustomElement: defineCustomElementCosmosRadioGroup
});
export const CosmosSelect = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-select',
    defaultProps: { invalid: false, multiple: false, required: false },
    defineCustomElement: defineCustomElementCosmosSelect
});
export const CosmosSelectValue = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-select-value',
    defaultProps: { multiple: false },
    defineCustomElement: defineCustomElementCosmosSelectValue
});
export const CosmosSpinner = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-spinner',
    defaultProps: {},
    defineCustomElement: defineCustomElementCosmosSpinner
});
export const CosmosStoryCard = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-story-card',
    defaultProps: { favoritable: false, favorited: false, layout: 'normal', logoAlt: '' },
    defineCustomElement: defineCustomElementCosmosStoryCard
});
export const CosmosStoryItem = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-story-item',
    defaultProps: { size: 'small' },
    defineCustomElement: defineCustomElementCosmosStoryItem
});
export const CosmosText = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-text',
    defaultProps: { kind: 'normal', size: 'medium', spacing: 'none', tag: 'p', weight: 'regular' },
    defineCustomElement: defineCustomElementCosmosText
});
export const CosmosTextarea = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-textarea',
    defaultProps: { disabled: false, invalid: false, readonly: false, required: false, resizable: false, rows: 4, value: '' },
    defineCustomElement: defineCustomElementCosmosTextarea
});
export const CosmosTitle = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-title',
    defaultProps: { size: 'medium', spacing: 'none', tag: 'p', weight: 'bold' },
    defineCustomElement: defineCustomElementCosmosTitle
});
export const CosmosTooltip = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-tooltip',
    defaultProps: { content: '', controlled: false, follow: false, offset: 8, placement: 'above', spacing: 'tight', unreachable: false, visible: false },
    defineCustomElement: defineCustomElementCosmosTooltip
});
export const CosmosVideoCard = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-video-card',
    defaultProps: { favoritable: false, favorited: false, layout: 'normal', logoAlt: '' },
    defineCustomElement: defineCustomElementCosmosVideoCard
});
export const CosmosVideoItem = /*@__PURE__*/ createPreactComponent({
    tagName: 'cosmos-video-item',
    defaultProps: { size: 'small' },
    defineCustomElement: defineCustomElementCosmosVideoItem
});
export const DeprecatedComponent = /*@__PURE__*/ createPreactComponent({
    tagName: 'deprecated-component',
    defaultProps: { deprecatedPropValue: 'value-c', updatedPropValue: 'new-value' },
    defineCustomElement: defineCustomElementDeprecatedComponent
});
